import {
  ACCOUNTING_SERVICES_INDUSTRY_GROUP,
  ACTIVITIES_RELATED_TO_CREDIT_INTERMEDIATION_INDUSTRY_GROUP,
  ACTIVITIES_RELATED_TO_REAL_ESTATE_INDUSTRY_GROUP,
  ADVERTISING_SERVICES_INDUSTRY_GROUP,
  AEROSPACE_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
  AGENCIES_BROKERAGES_INDUSTRY_GROUP,
  AGRICULTURE_CONSTRUCTION_MANUFACTURING_INDUSTRY_GROUP,
  ALUMINA_AND_ALUMINUM_PRODUCTION_INDUSTRY_GROUP,
  AMUSEMENT_PARKS_INDUSTRY_GROUP,
  ANIMAL_FOOD_MANUFACTURING_INDUSTRY_GROUP,
  ANIMAL_SLAUGHTERING_INDUSTRY_GROUP,
  APPAREL_ACCESSORIES_INDUSTRY_GROUP,
  APPAREL_KNITTING_MILLS_INDUSTRY_GROUP,
  APPAREL_PIECE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
  AQUACULTURE_INDUSTRY_GROUP,
  ARCHITECTURAL_METALS_MANUFACTURING_INDUSTRY_GROUP,
  ARCHITECTURAL_SERVICES_INDUSTRY_GROUP,
  ARTISTS_AGENTS_AND_MANAGERS_INDUSTRY_GROUP,
  AUDIO_VIDEO_MANUFACTURING_INDUSTRY_GROUP,
  AUTO_DEALERS_INDUSTRY_GROUP,
  AUTOMOTIVE_LEASING_INDUSTRY_GROUP,
  AUTOMOTIVE_PARTS_INDUSTRY_GROUP,
  AUTOMOTIVE_REPAIR_INDUSTRY_GROUP,
  BAKERIES_MANUFACTURING_INDUSTRY_GROUP,
  BASIC_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP,
  BEER_WINE_LIQUOR_RETAILERS_INDUSTRY_GROUP,
  BEER_WINE_WHOLESALERS_INDUSTRY_GROUP,
  BEVERAGE_MANUFACTURING_INDUSTRY_GROUP,
  BOILERS_TANK_MANUFACTURING_INDUSTRY_GROUP,
  BOOK_RETAILERS_INDUSTRY_GROUP,
  BUILDING_EQUIPMENT_CONTRACTOR_INDUSTRY_GROUP,
  BUILDING_FINISHING_CONTRACTOR_INDUSTRY_GROUP,
  BUILDING_MATERIAL_AND_SUPPLIES_DEALERS_INDUSTRY_GROUP,
  BUSINESS_LABOR_POLITICAL_INDUSTRY_GROUP,
  BUSINESS_SCHOOLS_INDUSTRY_GROUP,
  BUSINESS_SUPPORT_SERVICES_INDUSTRY_GROUP,
  CATTLE_RANCHING_FARMING_INDUSTRY_GROUP,
  CEMENT_AND_CONCRETE_MANUFACTURING_INDUSTRY_GROUP,
  CHARTER_BUS_INDUSTRY_GROUP,
  CHEMICAL_AND_ALLIED_PRODUCTS_WHOLESALERS_INDUSTRY_GROUP,
  CHILD_CARE_SERVICES_INDUSTRY_GROUP,
  CLAY_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
  CLOTHING_RETAILERS_INDUSTRY_GROUP,
  COAL_MINING_INDUSTRY_GROUP,
  COATING_ENGRAVING_HEAT_TREATING_INDUSTRY_GROUP,
  COMMERCIAL_AND_SERVICE_INDUSTRY_MANUFACTURING_INDUSTRY_GROUP,
  COMMERCIAL_MACHINERY_INDUSTRY_GROUP,
  COMMERCIAL_REPAIR_AND_MAINTENANCE_INDUSTRY_GROUP,
  COMMODITY_CONTRACTS_INDUSTRY_GROUP,
  COMMODITY_EXCHANGES_INDUSTRY_GROUP,
  COMMUNICATION_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  COMPUTER_MANUFACTURING_INDUSTRY_GROUP,
  COMPUTER_SYSTEMS_DESIGN_SERVICES_INDUSTRY_GROUP,
  CONSUMER_GOODS_RENTAL_INDUSTRY_GROUP,
  CONVERTED_PAPER_MANUFACTURING_INDUSTRY_GROUP,
  COURIER_DELIVERY_INDUSTRY_GROUP,
  CRUDE_OIL_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
  CUT_AND_SEW_APPAREL_INDUSTRY_GROUP,
  CUTLERY_AND_HANDTOOL_MANUFACTURING_INDUSTRY_GROUP,
  DAIRY_MANUFACTURING_INDUSTRY_GROUP,
  DEATH_CARE_SERVICES_INDUSTRY_GROUP,
  DEEP_SEA_TRANSPORTATION_INDUSTRY_GROUP,
  DENTISTS_INDUSTRY_GROUP,
  DEPARTMENT_STORE_INDUSTRY_GROUP,
  DEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP,
  DESIGN_SERVICES_INDUSTRY_GROUP,
  DRINKING_PLACES_INDUSTRY_GROUP,
  DRUGS_WHOLESALERS_INDUSTRY_GROUP,
  EDUCATIONAL_SUPPORT_SERVICES_INDUSTRY_GROUP,
  ELECTRIC_LIGHTING_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  ELECTRIC_POWER_GENERATION_INDUSTRY_GROUP,
  ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  ELECTRONICS_REPAIR_INDUSTRY_GROUP,
  ELECTRONICS_RETAILERS_INDUSTRY_GROUP,
  ELEMENTARY_SCHOOLS_INDUSTRY_GROUP,
  EMPLOYMENTS_SERVICES_INDUSTRY_GROUP,
  ENGINE_TURBINE_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  FABRIC_MILLS_INDUSTRY_GROUP,
  FACILITIES_SUPPORT_SERVICES_INDUSTRY_GROUP,
  FARM_PRODUCT_WHOLESALERS_INDUSTRY_GROUP,
  FIBER_YARN_MILLS_INDUSTRY_GROUP,
  FISHING_INDUSTRY_GROUP,
  FLORISTS_INDUSTRY_GROUP,
  FOOTWEAR_MANUFACTURING_INDUSTRY_GROUP,
  FOREST_NURSERIES_INDUSTRY_GROUP,
  FORGING_AND_STAMPING_INDUSTRY_GROUP,
  FOUNDATION_CONTRACTOR_INDUSTRY_GROUP,
  FOUNDRIES_INDUSTRY_GROUP,
  FREIGHT_TRANSPORTATION_AGREEMENT_INDUSTRY_GROUP,
  FRUIT_AND_TREE_NUT_INDUSTRY_GROUP,
  FRUIT_PRESERVING_MANUFACTURING_INDUSTRY_GROUP,
  FUEL_DEALERS_INDUSTRY_GROUP,
  FURNITURE_RETAILERS_INDUSTRY_GROUP,
  GAMBLING_INDUSTRIES_INDUSTRY_GROUP,
  GASOLINE_STATIONS_INDUSTRY_GROUP,
  GENERAL_FREIGHT_TRUCKING_INDUSTRY_GROUP,
  GENERAL_MEDICAL_INDUSTRY_GROUP,
  GENERAL_RENTAL_CENTERS_INDUSTRY_GROUP,
  GLASS_MANUFACTURING_INDUSTRY_GROUP,
  GRAIN_AND_OILSEED_MILLING_INDUSTRY_GROUP,
  GRANTMAKING_INDUSTRY_GROUP,
  GREENHOUSE_NURSERY_AND_FLORICULTURE_INDUSTRY_GROUP,
  GROCERY_RETAILERS_INDUSTRY_GROUP,
  GROCERY_WHOLESALERS_INDUSTRY_GROUP,
  HARDWARE_AND_PLUMBING_WHOLESALERS_INDUSTRY_GROUP,
  HARDWARE_MANUFACTURING_INDUSTRY_GROUP,
  HIGHWAY_CONSTRUCTION_INDUSTRY_GROUP,
  HOD_AND_PIG_FARMING_INDUSTRY_GROUP,
  HOME_HEALTH_CARE_SERVICES_INDUSTRY_GROUP,
  HOUSEHOLD_APPLIANCE_MANUFACTURING_INDUSTRY_GROUP,
  HOUSEHOLD_APPLIANCES_WHOLESALERS_INDUSTRY_GROUP,
  HOUSEHOLD_MANUFACTURING_INDUSTRY_GROUP,
  HUNTING_AND_TRAPPING_INDUSTRY_GROUP,
  INDEPENDENT_ARTISTS_INDUSTRY_GROUP,
  INDIVIDUAL_AND_FAMILY_SERVICES_INDUSTRY_GROUP,
  INDUSTRIAL_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
  INLAND_WATER_TRANSPORTATION_INDUSTRY_GROUP,
  INSURANCE_CARRIER_INDUSTRY_GROUP,
  INSURANCE_FUNDS_INDUSTRY_GROUP,
  INTERURBAN_TRANSPORTATION_INDUSTRY_GROUP,
  INVESTIGATION_AND_SECURITY_SERVICES_INDUSTRY_GROUP,
  IRON_AND_STEEL_MILLS_INDUSTRY_GROUP,
  JEWELRY_RETAILERS_INDUSTRY_GROUP,
  JUNIOR_COLLEGES_INDUSTRY_GROUP,
  LAND_SUBDIVISION_INDUSTRY_GROUP,
  LAUNDRY_SERVICES_INDUSTRY_GROUP,
  LAWN_AND_GARDEN_EQUIPMENT_INDUSTRY_GROUP,
  LEATHER_AND_HIDE_TANNING_INDUSTRY_GROUP,
  LEGAL_SERVICES_INDUSTRY_GROUP,
  LESSORS_OF_REAL_ESTATE_INDUSTRY_GROUP,
  LIME_AND_GYPSUM_MANUFACTURING_INDUSTRY_GROUP,
  LOCAL_DELIVERY_INDUSTRY_GROUP,
  LOGGING_INDUSTRY_GROUP,
  MACHINE_SHOPS_MANUFACTURING_INDUSTRY_GROUP,
  MACHINERY_WHOLESALERS_INDUSTRY_GROUP,
  MANUFACTURING_AND_REPRODUCING_MAGNETIC_AND_OPTICAL_MEDIA_INDUSTRY_GROUP,
  MEDIA_STREAMING_INDUSTRY_GROUP,
  MEDICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  MEDICAL_LABS_INDUSTRY_GROUP,
  METAL_AND_MINERAL_WHOLESALERS_INDUSTRY_GROUP,
  METAL_ORE_MINING_INDUSTRY_GROUP,
  METALWORKING_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
  MISCELLANEOUS_DURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
  MISCELLANEOUS_NONDURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
  MOTION_PICTURE_INDUSTRY_GROUP,
  MOTOR_VEHICLE_MANUFACTURING_INDUSTRY_GROUP,
  NATURAL_GAS_DISTRIBUTION_INDUSTRY_GROUP,
  NATURAL_GAS_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
  NAVIGATIONAL_INSTRUMENTS_INDUSTRY_GROUP,
  NEWSPAPER_INDUSTRY_GROUP,
  NONDEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP,
  NONFERROUS_METAL_PRODUCTION_INDUSTRY_GROUP,
  NONMETALLIC_MINERAL_MINING_INDUSTRY_GROUP,
  NONRESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP,
  NONSCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP,
  NURSING_CARE_FACILITIES_INDUSTRY_GROUP,
  OFFICE_ADMINISTRATIVE_SERVICES_INDUSTRY_GROUP,
  OFFICE_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
  OFFICE_SUPPLY_RETAILERS_INDUSTRY_GROUP,
  OFFICES_OF_REAL_ESTATE_INDUSTRY_GROUP,
  OILSEED_AND_GRAIN_INDUSTRY_GROUP,
  OTHER_AMBULATORY_HEALTH_CARE_INDUSTRY_GROUP,
  OTHER_AMUSEMENT_INDUSTRY_GROUP,
  OTHER_ANIMAL_PRODUCTION_INDUSTRY_GROUP,
  OTHER_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_CROP_FARMING_INDUSTRY_GROUP,
  OTHER_EATING_PLACES_INDUSTRY_GROUP,
  OTHER_ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_FABRICATED_TOOL_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_FINANCIAL_INVESTMENT_ACTIVITIES_INDUSTRY_GROUP,
  OTHER_FOOD_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_FUNDS_FUNDS_INDUSTRY_GROUP,
  OTHER_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_GENERAL_PURPOSE_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_HEALTH_PRACTITIONERS_INDUSTRY_GROUP,
  OTHER_HEAVY_CONSTRUCTION_INDUSTRY_GROUP,
  OTHER_LEATHER_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_MISCELLANEOUS_INDUSTRY_GROUP,
  OTHER_MISCELLANEOUS_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_MOTOR_DEALERS_INDUSTRY_GROUP,
  OTHER_NONMETALLIC_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_PERSONAL_SERVICES_INDUSTRY_GROUP,
  OTHER_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
  OTHER_RELIEF_SERVICES_INDUSTRY_GROUP,
  OTHER_RESIDENTIAL_CARE_INDUSTRY_GROUP,
  OTHER_SCHOOLS_INDUSTRY_GROUP,
  OTHER_SPECIALTY_TRADE_CONTRACTORS_INDUSTRY_GROUP,
  OTHER_SUPPORT_SERVICES_INDUSTRY_GROUP,
  OTHER_SUPPORT_TRANSPORTATION_INDUSTRY_GROUP,
  OTHER_TECHNICAL_SERVICES_INDUSTRY_GROUP,
  OTHER_TELECOMMUNICATIONS_INDUSTRY_GROUP,
  OTHER_TEXTILE_MILLS_INDUSTRY_GROUP,
  OTHER_TRANSIT_TRANSPORTATION_INDUSTRY_GROUP,
  OTHER_TRANSPORTATION_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_WOOD_PRODUCT_INDUSTRY_GROUP,
  OUTPATIENT_CARE_CENTERS_INDUSTRY_GROUP,
  PAINT_COATING_MANUFACTURING_INDUSTRY_GROUP,
  PAPER_AND_PRODUCT_WHOLESALERS_INDUSTRY_GROUP,
  PERFORMING_ARTS_COMPANIES_INDUSTRY_GROUP,
  PERSONAL_CARE_SERVICES_INDUSTRY_GROUP,
  PERSONAL_GOODS_REPAIR_INDUSTRY_GROUP,
  PESTICIDE_FERTILIZER_MANUFACTURING_INDUSTRY_GROUP,
  PETROLEUM_WHOLESALERS_INDUSTRY_GROUP,
  PHARMACEUTICAL_AND_MEDICINE_MANUFACTURING_INDUSTRY_GROUP,
  PHYSICIANS_INDUSTRY_GROUP,
  PLASTIC_MANUFACTURING_INDUSTRY_GROUP,
  POULTRY_AND_EGG_INDUSTRY_GROUP,
  PROF_AND_COMMERCIAL_EQUIPMENT_WHOLESALERS_INDUSTRY_GROUP,
  PROFESSIONAL_SCHOOLS_INDUSTRY_GROUP,
  PROMOTERS_OF_PERFORMING_ARTS_INDUSTRY_GROUP,
  PULP_PAPER_MILLS_INDUSTRY_GROUP,
  RADIO_AND_TELEVISION_INDUSTRY_GROUP,
  RAILROAD_MANUFACTURING_INDUSTRY_GROUP,
  RECREATIONAL_CAMPS_INDUSTRY_GROUP,
  RELIGIOUS_ORGANIZATIONS_INDUSTRY_GROUP,
  REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICE_INDUSTRY_GROUP,
  RESERVATION_SERVICES_INDUSTRY_GROUP,
  RESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP,
  RESIDENTIAL_INTELLECTUAL_INDUSTRY_GROUP,
  RESIN_SYNTHETIC_RUBBER_MANUFACTURING_INDUSTRY_GROUP,
  RETIREMENT_COMMUNITIES_INDUSTRY_GROUP,
  RUBBER_MANUFACTURING_INDUSTRY_GROUP,
  SATELLITE_TELECOMMUNICATIONS_INDUSTRY_GROUP,
  SAWMILLS_AND_WOOD_PRESERVATION_INDUSTRY_GROUP,
  SCENIC_LAND_INDUSTRY_GROUP,
  SCENIC_OTHER_INDUSTRY_GROUP,
  SCENIC_WATER_INDUSTRY_GROUP,
  SCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP,
  SCHOOL_TRANSPORTATION_INDUSTRY_GROUP,
  SCIENTIFIC_RESEARCH_SERVICES_INDUSTRY_GROUP,
  SEAFOOD_PREPARATION_INDUSTRY_GROUP,
  SEMICONDUCTOR_MANUFACTURING_INDUSTRY_GROUP,
  SERVICES_TO_BUILDINGS_INDUSTRY_GROUP,
  SHEEP_AND_GOAT_INDUSTRY_GROUP,
  SHIP_AND_BOAT_BUILDING_INDUSTRY_GROUP,
  SHOE_RETAILERS_INDUSTRY_GROUP,
  SOAP_CLEANING_COMPOUND_MANUFACTURING_INDUSTRY_GROUP,
  SOCIAL_ADVOCACY_INDUSTRY_GROUP,
  SOCIAL_ORGANIZATIONS_INDUSTRY_GROUP,
  SOFTWARE_PUBLISHERS_INDUSTRY_GROUP,
  SOUND_INDUSTRY_GROUP,
  SPECIAL_FOOD_SERVICES_INDUSTRY_GROUP,
  SPECIALIZED_FREIGHT_TRUCKING_INDUSTRY_GROUP,
  SPECIALTY_FOOD_RETAILERS_INDUSTRY_GROUP,
  SPECIALTY_HOSPITALS__INDUSTRY_GROUP,
  SPECTATOR_SPORTS_INDUSTRY_GROUP,
  SPORTING_GOODS_RETAILERS_INDUSTRY_GROUP,
  SPRING_AND_WIRE_MANUFACTURING_INDUSTRY_GROUP,
  STEEL_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
  SUBSTANCE_ABUSE_HOSPITALS_INDUSTRY_GROUP,
  SUGAR_MANUFACTURING_INDUSTRY_GROUP,
  SUPPORT_ACTIVITIES_FOR_CROP_INDUSTRY_GROUP,
  SUPPORT_FOR_AIR_TRANSPORTATION_INDUSTRY_GROUP,
  SUPPORT_FOR_RAIL_TRANSPORTATION_INDUSTRY_GROUP,
  SUPPORT_FOR_ROAD_TRANSPORTATION_INDUSTRY_GROUP,
  SUPPORT_FOR_WATER_TRANSPORTATION_INDUSTRY_GROUP,
  TAXI_SERVICE_INDUSTRY_GROUP,
  TECHNICAL_CONSULTING_SERVICES_INDUSTRY_GROUP,
  TEXTILE_FURNISHING_MILLS_INDUSTRY_GROUP,
  TEXTILE_MILLS_INDUSTRY_GROUP,
  TIMBER_TRACK_OPERATIONS_INDUSTRY_GROUP,
  TOBACCO_MANUFACTURING_INDUSTRY_GROUP,
  TRADE_SCHOOLS_INDUSTRY_GROUP,
  TRAVELER_ACCOMMODATION_INDUSTRY_GROUP,
  URBAN_TRANSIT_SYSTEMS_INDUSTRY_GROUP,
  USED_MERCHANDISE_INDUSTRY_GROUP,
  UTILITY_SYSTEM_CONSTRUCTION_INDUSTRY_GROUP,
  VEGETABLE_AND_MELON_INDUSTRY_GROUP,
  VEHICLE_BODY_MANUFACTURING_INDUSTRY_GROUP,
  VEHICLE_PARTS_MANUFACTURING_INDUSTRY_GROUP,
  VENEER_PLYWOOD_INDUSTRY_GROUP,
  VENTILATION_HEATING_AIR_CONDITIONING_MANUFACTURING_INDUSTRY_GROUP,
  VOCATIONAL_REHABILITATION_SERVICES_INDUSTRY_GROUP,
  WAREHOUSE_CLUBS_RETAILERS_INDUSTRY_GROUP,
  WASTE_COLLECTION_INDUSTRY_GROUP,
  WASTE_DISPOSAL_INDUSTRY_GROUP,
  WIRED_TELECOMMUNICATIONS_INDUSTRY_GROUP,
  WORKERS_CAMPS_INDUSTRY_GROUP,
} from '../industryGroupOptions';
import { MANAGEMENT_OF_COMPANIES_SECTOR } from '../industrySectorOptions';
import {
  ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR,
  ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR,
  AGENTS_AND_BROKERS_SUB_SECTOR,
  COMPUTING_INFRASTRUCTURE_SUB_SECTOR,
  EXECUTIVE_LEGISLATIVE_SUB_SECTOR,
  HEALTH_RETAILERS_SUB_SECTOR,
  JUSTICE_PUBLIC_ORDER_SUB_SECTOR,
  LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR,
  MINING_SUPPORT_ACTIVITIES_SUB_SECTOR,
  MONETARY_BANK_SUB_SECTOR,
  MUSEUMS_SUB_SECTOR,
  NATIONAL_SECURITY_SUB_SECTOR,
  OIL_GAS_EXTRACTION_SUB_SECTOR,
  PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR,
  POSTAL_SERVICE_SUB_SECTOR,
  PRINTING_MANUFACTURING_SUB_SECTOR,
  PRIVATE_HOUSEHOLDS_SUB_SECTOR,
  RAIL_TRANSPORTATION_SUB_SECTOR,
  SPACE_RESEARCH_SUB_SECTOR,
  WAREHOUSING_AND_STORAGE_SUB_SECTOR,
  WEB_SEARCH_PORTALS_SUB_SECTOR,
} from '../industrySubSectorOptions';

export const INDUSTRY_OPTIONS_UA = {
  [OILSEED_AND_GRAIN_INDUSTRY_GROUP]: [
    { value: '11111', label: 'Вирощування сої' },
    { value: '11112', label: 'Вирощування олійних культур (крім сої)' },
    { value: '11113', label: 'Вирощування гороху та квасолі' },
    { value: '11114', label: 'Вирощування пшениці' },
    { value: '11115', label: 'Вирощування кукурудзи' },
    { value: '11116', label: 'Вирощування рису' },
    { value: '111191', label: 'Комбіноване вирощування зернових та олійних культур' },
    { value: '111199', label: 'Інше вирощування зернових культур' },
  ],
  [VEGETABLE_AND_MELON_INDUSTRY_GROUP]: [
    { value: '111211', label: 'Вирощування картоплі' },
    { value: '111219', label: 'Вирощування інших овочів (крім картоплі) та баштанних культур' },
  ],
  [FRUIT_AND_TREE_NUT_INDUSTRY_GROUP]: [
    { value: '11131', label: 'Вирощування апельсинів' },
    { value: '11132', label: 'Вирощування цитрусових (крім апельсинів)' },
    { value: '111331', label: 'Яблуневі сади' },
    { value: '111332', label: 'Виноградники' },
    { value: '111333', label: 'Вирощування полуниці' },
    { value: '111334', label: 'Вирощування ягід (крім полуниці)' },
    { value: '111335', label: 'Вирощування горіхових культур' },
    { value: '111336', label: 'Комбіноване вирощування фруктів і горіхів' },
    { value: '111339', label: 'Вирощування інших нецитрусових фруктів' },
  ],
  [GREENHOUSE_NURSERY_AND_FLORICULTURE_INDUSTRY_GROUP]: [
    { value: '111411', label: 'Вирощування грибів' },
    { value: '111419', label: 'Інші харчові культури, вирощувані під укриттям' },
    { value: '111421', label: 'Розсадники та вирощування дерев' },
    { value: '111422', label: 'Вирощування квітково-декоративних культур' },
  ],
  [OTHER_CROP_FARMING_INDUSTRY_GROUP]: [
    { value: '11191', label: 'Вирощування тютюну' },
    { value: '11192', label: 'Вирощування бавовнику' },
    { value: '11193', label: 'Вирощування цукрової тростини' },
    { value: '11194', label: 'Виробництво сіна' },
    { value: '111991', label: 'Вирощування цукрових буряків' },
    { value: '111992', label: 'Вирощування арахісу' },
    { value: '111998', label: 'Інше різне вирощування сільськогосподарських культур' },
  ],
  [CATTLE_RANCHING_FARMING_INDUSTRY_GROUP]: [
    { value: '112111', label: 'Розведення та вирощування м’ясної худоби' },
    { value: '112112', label: 'Відгодівля великої рогатої худоби' },
    { value: '11212', label: 'Молочне скотарство та виробництво молока' },
    { value: '11213', label: 'Розведення худоби подвійного призначення' },
  ],
  [HOD_AND_PIG_FARMING_INDUSTRY_GROUP]: [],
  [POULTRY_AND_EGG_INDUSTRY_GROUP]: [
    { value: '11231', label: 'Виробництво курячих яєць' },
    { value: '11232', label: 'Виробництво бройлерів та іншого м’ясного курчат' },
    { value: '11233', label: 'Виробництво індички' },
    { value: '11233', label: 'Птахівничі інкубатори' },
    { value: '11239', label: 'Інше птахівництво' },
  ],
  [SHEEP_AND_GOAT_INDUSTRY_GROUP]: [
    { value: '11241', label: 'Вівчарство' },
    { value: '11242', label: 'Козівництво' },
  ],
  [AQUACULTURE_INDUSTRY_GROUP]: [
    { value: '112511', label: 'Вирощування промислових риб та риборозплідники' },
    { value: '112512', label: 'Вирощування молюсків' },
    { value: '112519', label: 'Інша аквакультура' },
  ],
  [OTHER_ANIMAL_PRODUCTION_INDUSTRY_GROUP]: [
    { value: '11291', label: 'Бджільництво' },
    { value: '11292', label: 'Розведення коней та інших непарнокопитних' },
    { value: '11293', label: 'Розведення хутрових тварин і кролів' },
    { value: '11299', label: 'Інше тваринництво' },
  ],
  [TIMBER_TRACK_OPERATIONS_INDUSTRY_GROUP]: [],
  [FOREST_NURSERIES_INDUSTRY_GROUP]: [],
  [LOGGING_INDUSTRY_GROUP]: [],
  [FISHING_INDUSTRY_GROUP]: [
    { value: '114111', label: 'Промисловий вилов риби' },
    { value: '114112', label: 'Вилов молюсків' },
    { value: '114119', label: 'Інший морський вилов' },
  ],
  [HUNTING_AND_TRAPPING_INDUSTRY_GROUP]: [],
  [SUPPORT_ACTIVITIES_FOR_CROP_INDUSTRY_GROUP]: [
    { value: '115111', label: 'Первинна переробка бавовнику (джинування)' },
    { value: '115112', label: 'Підготовка ґрунту, посів і обробіток культур' },
    { value: '115113', label: 'Збирання врожаю, переважно механізоване' },
    { value: '115114', label: 'Післязбиральна обробка культур (крім джинування бавовнику)' },
    { value: '115115', label: 'Посередники в наймі сільськогосподарських працівників і бригадири' },
    { value: '115116', label: 'Послуги з управління сільськогосподарськими підприємствами' },
  ],
  [OIL_GAS_EXTRACTION_SUB_SECTOR]: [
    { value: '21112', label: 'Добування сирої нафти' },
    { value: '21113', label: 'Добування природного газу' },
  ],
  [COAL_MINING_INDUSTRY_GROUP]: [
    { value: '212114', label: 'Відкритий видобуток вугілля' },
    { value: '212115', label: 'Підземний видобуток вугілля' },
  ],
  [METAL_ORE_MINING_INDUSTRY_GROUP]: [
    { value: '21221', label: 'Видобуток залізної руди' },
    { value: '21222', label: 'Видобуток золотої та срібної руди' },
    { value: '21223', label: 'Видобуток міді, нікелю, свинцю та цинку' },
    { value: '21229', label: 'Видобуток інших металевих руд' },
  ],
  [NONMETALLIC_MINERAL_MINING_INDUSTRY_GROUP]: [
    { value: '212311', label: 'Видобуток і розробка блокового каменю' },
    { value: '212312', label: 'Видобуток та дроблення вапняку' },
    { value: '212313', label: 'Видобуток та дроблення граніту' },
    { value: '212319', label: 'Видобуток та дроблення іншого каменю' },
    { value: '212321', label: 'Видобуток будівельного піску та гравію' },
    { value: '212322', label: 'Видобуток промислового піску' },
    { value: '212323', label: 'Видобуток каоліну, глин, керамічної та вогнетривкої сировини' },
    { value: '21239', label: 'Видобуток інших неметалевих корисних копалин і розробка кар’єрів' },
  ],
  [MINING_SUPPORT_ACTIVITIES_SUB_SECTOR]: [
    { value: '213111', label: 'Буріння нафтових і газових свердловин' },
    { value: '213112', label: 'Допоміжна діяльність у нафтогазовидобутку' },
    { value: '213113', label: 'Допоміжна діяльність у видобутку вугілля' },
    { value: '213114', label: 'Допоміжна діяльність у видобутку металевих руд' },
    { value: '213115', label: 'Допоміжна діяльність у видобутку неметалевих корисних копалин (крім палива)' },
  ],
  [ELECTRIC_POWER_GENERATION_INDUSTRY_GROUP]: [
    { value: '221111', label: 'Виробництво гідроелектроенергії' },
    { value: '221112', label: 'Виробництво електроенергії з викопного палива' },
    { value: '221113', label: 'Виробництво ядерної електроенергії' },
    { value: '221114', label: 'Виробництво сонячної електроенергії' },
    { value: '221115', label: 'Виробництво вітрової електроенергії' },
    { value: '221116', label: 'Виробництво геотермальної електроенергії' },
    { value: '221117', label: 'Виробництво електроенергії з біомаси' },
    { value: '221118', label: 'Інше виробництво електроенергії' },
    { value: '221121', label: 'Передача та диспетчеризація оптової електроенергії' },
    { value: '221122', label: 'Розподіл електроенергії' },
  ],
  [NATURAL_GAS_DISTRIBUTION_INDUSTRY_GROUP]: [
    { value: '22131', label: 'Системи водопостачання та зрошення' },
    { value: '22132', label: 'Об’єкти очищення стічних вод' },
    { value: '22133', label: 'Постачання пари та кондиціонованого повітря' },
  ],
  [RESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP]: [
    { value: '236115', label: 'Будівництво нових односімейних житлових будинків (крім забудовників на продаж)' },
    { value: '236116', label: 'Будівництво нових багатоквартирних будинків (крім забудовників на продаж)' },
    { value: '236117', label: 'Будівництво нового житла забудовниками для продажу' },
    { value: '236118', label: 'Реконструкція та ремонт житла' },
  ],
  [NONRESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP]: [
    { value: '23621', label: 'Будівництво промислових будівель' },
    { value: '23622', label: 'Будівництво комерційних та інституційних будівель' },
  ],
  [UTILITY_SYSTEM_CONSTRUCTION_INDUSTRY_GROUP]: [
    { value: '23711', label: 'Будівництво водопровідних і каналізаційних мереж та споруд' },
    { value: '23712', label: 'Будівництво нафтогазопроводів та споруд' },
    { value: '23713', label: 'Будівництво ліній електропередачі та зв’язку та споруд' },
  ],
  [LAND_SUBDIVISION_INDUSTRY_GROUP]: [],
  [HIGHWAY_CONSTRUCTION_INDUSTRY_GROUP]: [],
  [OTHER_HEAVY_CONSTRUCTION_INDUSTRY_GROUP]: [],
  [FOUNDATION_CONTRACTOR_INDUSTRY_GROUP]: [
    { value: '23811', label: 'Підрядники з улаштування монолітних бетонних фундаментів і конструкцій' },
    { value: '23812', label: 'Підрядники зі сталевих та збірних залізобетонних конструкцій' },
    { value: '23813', label: 'Підрядники з монтажу каркасів' },
    { value: '23814', label: 'Підрядники з мурування' },
    { value: '23815', label: 'Підрядники зі скління' },
    { value: '23816', label: 'Покрівельні підрядники' },
    { value: '23817', label: 'Підрядники з облицювання фасадів ' },
    { value: '23819', label: 'Інші підрядники з фундаментів, конструкцій та зовнішніх елементів будівель' },
  ],
  [BUILDING_EQUIPMENT_CONTRACTOR_INDUSTRY_GROUP]: [
    {
      value: '23821',
      label: 'Електромонтажні та інші підрядники з прокладання електропроводки',
    },
    {
      value: '23822',
      label: 'Підрядники з сантехнічних, опалювальних та кондиціонерних систем',
    },
    { value: '23829', label: 'Інші підрядники з монтажу інженерного обладнання будівель' },
  ],
  [BUILDING_FINISHING_CONTRACTOR_INDUSTRY_GROUP]: [
    { value: '23831', label: 'Підрядники з монтажу гіпсокартону та утеплення' },
    { value: '23832', label: 'Підрядники з фарбування та облицювання стін' },
    { value: '23833', label: 'Підрядники з настилу підлог' },
    { value: '23834', label: 'Підрядники з укладання плитки та террацо' },
    { value: '23835', label: 'Підрядники зі столярних оздоблювальних робіт' },
    { value: '23839', label: 'Інші підрядники з внутрішнього оздоблення будівель' },
  ],
  [OTHER_SPECIALTY_TRADE_CONTRACTORS_INDUSTRY_GROUP]: [
    { value: '23891', label: 'Підрядники з підготовки будівельних майданчиків' },
    { value: '23899', label: 'Інші спеціалізовані підрядники' },
  ],
  [ANIMAL_FOOD_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311111', label: 'Виробництво кормів для собак і котів' },
    { value: '311119', label: 'Виробництво інших кормів для тварин' },
  ],
  [GRAIN_AND_OILSEED_MILLING_INDUSTRY_GROUP]: [
    { value: '311211', label: 'Виробництво борошна' },
    { value: '311212', label: 'Виробництво рисового борошна/шліфування рису' },
    { value: '311213', label: 'Виробництво солоду' },
    { value: '311221', label: 'Виробництво крохмалю та вологе помел кукурудзи' },
    { value: '311224', label: 'Переробка сої та інших олійних культур' },
    { value: '311224', label: 'Рафінування та змішування жирів і олій' },
    { value: '31123', label: 'Виробництво сухих сніданків' },
  ],
  [SUGAR_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311313', label: 'Виробництво цукру з буряку' },
    { value: '311314', label: 'Виробництво цукру з тростини' },
    { value: '31134', label: 'Виробництво кондитерських виробів без шоколаду' },
    { value: '31135', label: 'Виробництво шоколаду та кондитерських виробів' },
  ],
  [FRUIT_PRESERVING_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311411', label: 'Виробництво заморожених фруктів, соків та овочів' },
    { value: '311412', label: 'Виробництво інших заморожених харчових продуктів' },
    { value: '311421', label: 'Консервування фруктів та овочів' },
    { value: '311422', label: 'Виробництво спеціалізованих консервів' },
    { value: '311423', label: 'Виробництво сушених та дегідрованих харчових продуктів' },
  ],
  [DAIRY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311511', label: 'Виробництво питного молока' },
    { value: '311512', label: 'Виробництво вершкового масла' },
    { value: '311513', label: 'Виробництво сиру' },
    {
      value: '311514',
      label: 'Виробництво сухих, згущених та випарених молочних продуктів',
    },
    { value: '31152', label: 'Виробництво морозива та заморожених десертів' },
  ],
  [ANIMAL_SLAUGHTERING_INDUSTRY_GROUP]: [
    { value: '311611', label: 'Забій тварин (крім птиці)' },
    { value: '311612', label: 'Переробка м’яса з туш' },
    { value: '311613', label: 'Переробка відходів м’ясного виробництва' },
    { value: '311615', label: 'Переробка птиці' },
  ],
  [SEAFOOD_PREPARATION_INDUSTRY_GROUP]: [],
  [BAKERIES_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311811', label: 'Роздрібні пекарні' },
    { value: '311812', label: 'Промислові пекарні' },
    {
      value: '311813',
      label: 'Виробництво заморожених тортів, пирогів та іншої випічки',
    },
    { value: '311821', label: 'Виробництво печива та крекерів' },
    {
      value: '311824',
      label: 'Виробництво сухих макаронів, тіста та борошняних сумішей із купленого борошна',
    },
    { value: '31183', label: 'Виробництво тортильї' },
  ],
  [OTHER_FOOD_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '311911',
      label: 'Виробництво смажених горіхів та арахісової пасти',
    },
    { value: '311919', label: 'Виробництво інших снекових продуктів' },
    { value: '31192', label: 'Виробництво кави та чаю' },
    { value: '31193', label: 'Виробництво ароматизованих сиропів і концентратів' },
    {
      value: '311941',
      label: 'Виробництво майонезу, заправок та інших готових соусів',
    },
    { value: '311942', label: 'Виробництво прянощів і екстрактів' },
    { value: '31199', label: 'Інше виробництво харчових продуктів' },
  ],
  [BEVERAGE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '312111', label: 'Виробництво безалкогольних напоїв' },
    { value: '312112', label: 'Виробництво бутильованої води' },
    { value: '312113', label: 'Виробництво льоду' },
    { value: '31212', label: 'Пивоварні' },
    { value: '31213', label: 'Виноробні' },
    { value: '31214', label: 'Дистилярні (виробництво міцних напоїв)' },
  ],
  [TOBACCO_MANUFACTURING_INDUSTRY_GROUP]: [],
  [FIBER_YARN_MILLS_INDUSTRY_GROUP]: [],
  [FABRIC_MILLS_INDUSTRY_GROUP]: [
    { value: '31321', label: 'Виробництво широкотканих матеріалів' },
    {
      value: '31322',
      label: 'Виробництво вузьких тканин та вишивка на машинах «шифлі»',
    },
    { value: '31323', label: 'Виробництво нетканих матеріалів' },
    { value: '31324', label: 'Виробництво трикотажних полотен' },
  ],
  [TEXTILE_MILLS_INDUSTRY_GROUP]: [
    { value: '31331', label: 'Оздоблення текстилю та тканин' },
    { value: '31332', label: 'Підприємства з нанесення покриттів на тканини' },
  ],
  [TEXTILE_FURNISHING_MILLS_INDUSTRY_GROUP]: [
    { value: '31411', label: 'Виробництво килимів та килимових покриттів' },
    { value: '31412', label: 'Виробництво штор та білизни' },
  ],
  [OTHER_TEXTILE_MILLS_INDUSTRY_GROUP]: [
    { value: '31491', label: 'Виробництво текстильних мішків і брезенту' },
    {
      value: '314994',
      label: 'Виробництво мотузок, шнурів, шпагату, корду та тканин для шин',
    },
    {
      value: '314999',
      label: 'Інше виробництво текстильних виробів',
    },
  ],
  [APPAREL_KNITTING_MILLS_INDUSTRY_GROUP]: [],
  [CUT_AND_SEW_APPAREL_INDUSTRY_GROUP]: [
    { value: '31521', label: 'Підрядники з розкрою та пошиття одягу' },
    {
      value: '31525',
      label: 'Виробництво одягу (крім підрядників з розкрою та пошиття)',
    },
  ],
  [APPAREL_ACCESSORIES_INDUSTRY_GROUP]: [],
  [LEATHER_AND_HIDE_TANNING_INDUSTRY_GROUP]: [],
  [FOOTWEAR_MANUFACTURING_INDUSTRY_GROUP]: [],
  [OTHER_LEATHER_MANUFACTURING_INDUSTRY_GROUP]: [],
  [SAWMILLS_AND_WOOD_PRESERVATION_INDUSTRY_GROUP]: [
    { value: '321113', label: 'Лісопильні' },
    { value: '321114', label: 'Консервація та просочування деревини' },
  ],
  [VENEER_PLYWOOD_INDUSTRY_GROUP]: [
    {
      value: '321211',
      label: 'Виробництво фанери та шпону з твердих порід дерева',
    },
    {
      value: '321212',
      label: 'Виробництво фанери та шпону з м’яких порід дерева',
    },
    {
      value: '321215',
      label: 'Виробництво клеєної та інженерної деревини',
    },
    {
      value: '321219',
      label: 'Виробництво відновлених (агломерованих) деревних виробів',
    },
  ],
  [OTHER_WOOD_PRODUCT_INDUSTRY_GROUP]: [
    {
      value: '321911',
      label: 'Виробництво дерев’яних вікон і дверей',
    },
    {
      value: '321912',
      label: 'Розкрій, повторне розпилювання та стругання пиломатеріалів',
    },
    {
      value: '321918',
      label: 'Інша деревообробка (включно з підлоговими покриттями)',
    },
    {
      value: '32192',
      label: 'Виробництво дерев’яної тари та піддонів',
    },
    {
      value: '321991',
      label: 'Виробництво збірних (мобільних) будинків',
    },
    {
      value: '321992',
      label: 'Виробництво збірних дерев’яних будівель',
    },
    {
      value: '321999',
      label: 'Інше виробництво дерев’яних виробів',
    },
  ],
  [PULP_PAPER_MILLS_INDUSTRY_GROUP]: [
    { value: '32211', label: 'Целюлозні заводи' },
    { value: '32212', label: 'Паперові фабрики' },
    { value: '32213', label: 'Виробництво картону' },
  ],
  [CONVERTED_PAPER_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '32221',
      label: 'Виробництво тари з картону',
    },
    {
      value: '32222',
      label: 'Виробництво паперових пакетів та просоченого/покритого паперу',
    },
    {
      value: '32223',
      label: 'Виробництво канцелярських виробів',
    },
    {
      value: '322291',
      label: 'Виробництво санітарно-гігієнічних паперових виробів',
    },
    {
      value: '322299',
      label: 'Інше виробництво паперових виробів',
    },
  ],
  [BASIC_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32511', label: 'Виробництво нафтохімічної продукції' },
    { value: '32512', label: 'Виробництво технічних газів' },
    {
      value: '32513',
      label: 'Виробництво синтетичних барвників та пігментів',
    },
    {
      value: '32518',
      label: 'Інше виробництво основних неорганічних хімікатів',
    },
    { value: '325193', label: 'Виробництво етилового спирту' },
    {
      value: '325194',
      label: 'Виробництво циклічних напівпродуктів, смол та деревної хімічної продукції',
    },
    {
      value: '325199',
      label: 'Інше виробництво основних органічних хімікатів',
    },
  ],
  [RESIN_SYNTHETIC_RUBBER_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '325211',
      label: 'Виробництво пластмас у первинних формах і смол',
    },
    { value: '325212', label: 'Виробництво синтетичного каучуку' },
    {
      value: '32522',
      label: 'Виробництво штучних та синтетичних волокон і ниток',
    },
  ],
  [PESTICIDE_FERTILIZER_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '325311', label: 'Виробництво азотних добрив' },
    { value: '325312', label: 'Виробництво фосфатних добрив' },
    {
      value: '325314',
      label: 'Виробництво змішаних добрив',
    },
    { value: '325315', label: 'Виробництво компосту' },
    {
      value: '32532',
      label: 'Виробництво пестицидів та інших агрохімікатів',
    },
  ],
  [PHARMACEUTICAL_AND_MEDICINE_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '325411',
      label: 'Виробництво лікарських засобів рослинного походження',
    },
    {
      value: '325412',
      label: 'Виробництво фармацевтичних препаратів',
    },
    {
      value: '325413',
      label: 'Виробництво реактивів для лабораторної діагностики in vitro',
    },
    {
      value: '325414',
      label: 'Виробництво біопрепаратів (крім діагностичних)',
    },
  ],
  [PAINT_COATING_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32551', label: 'Виробництво фарб і покриттів' },
    { value: '32552', label: 'Виробництво клеїв' },
  ],
  [SOAP_CLEANING_COMPOUND_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '325611',
      label: 'Виробництво мила та інших мийних засобів',
    },
    {
      value: '325612',
      label: 'Виробництво полірувальних та інших санітарно-гігієнічних засобів',
    },
    { value: '325613', label: 'Виробництво поверхнево-активних речовин' },
    { value: '32562', label: 'Виробництво туалетних засобів' },
  ],

  [OTHER_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32591', label: 'Виробництво друкарських фарб' },
    { value: '32592', label: 'Виробництво вибухових речовин' },
    { value: '325991', label: 'Індивідуальне компаундування придбаних смол' },
    {
      value: '325992',
      label: 'Виробництво фотоплівки, фотопаперу, фотопластин, фотохімікатів і копіювального тонера',
    },
    {
      value: '325998',
      label: 'Інше різноманітне виробництво хімічної продукції та хімічних препаратів',
    },
  ],
  [PLASTIC_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '326111', label: 'Виробництво пластикових пакетів і мішків' },
    {
      value: '326112',
      label: 'Виробництво пакувальної плівки та листів з пластмас (у тому числі ламінованих)',
    },
    {
      value: '326113',
      label: 'Виробництво неламінованої плівки та листів з пластмас (крім пакувальних)',
    },
    { value: '326121', label: 'Виробництво профільних виробів з неламінованих пластмас' },
    { value: '326122', label: 'Виробництво пластикових труб і фасонних частин до них' },
    {
      value: '32613',
      label: 'Виробництво ламінованих плит, листів (крім пакувальних) і профільних виробів з пластмас',
    },
    { value: '32614', label: 'Виробництво виробів з пінополістиролу' },
    {
      value: '32615',
      label: 'Виробництво виробів з поліуретанової та іншої піни (крім пінополістиролу)',
    },
    { value: '32616', label: 'Виробництво пластикових пляшок' },
    { value: '326191', label: 'Виробництво сантехнічних виробів з пластмас' },
    { value: '326199', label: 'Інше виробництво пластмасових виробів' },
  ],
  [RUBBER_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '326211', label: 'Виробництво шин (крім відновлення протектора)' },
    { value: '326212', label: 'Відновлення протектора шин' },
    {
      value: '32622',
      label: 'Виробництво гумових і пластикових рукавів та конвеєрних стрічок',
    },
    { value: '326291', label: 'Виробництво гумових виробів для механічного застосування' },
    { value: '326299', label: 'Інше виробництво гумових виробів' },
  ],
  [CLAY_PRODUCT_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '32711',
      label: 'Виробництво керамічного посуду, виробів та сантехнічних керамічних виробів',
    },
    {
      value: '32712',
      label: 'Виробництво будівельних глиняних матеріалів та вогнетривів',
    },
  ],
  [GLASS_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '327211', label: 'Виробництво листового скла' },
    {
      value: '327212',
      label: 'Виробництво іншого пресованого та видувного скла й скляних виробів',
    },
    { value: '327213', label: 'Виробництво скляної тари' },
    {
      value: '327215',
      label: 'Виробництво скляних виробів із придбаного скла',
    },
  ],
  [CEMENT_AND_CONCRETE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32731', label: 'Виробництво цементу' },
    { value: '32732', label: 'Виробництво готових бетонних сумішей' },
    { value: '327331', label: 'Виробництво бетонних блоків і цегли' },
    { value: '327332', label: 'Виробництво бетонних труб' },
    { value: '32739', label: 'Інше виробництво бетонних виробів' },
  ],
  [LIME_AND_GYPSUM_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32741', label: 'Виробництво вапна' },
    { value: '32742', label: 'Виробництво гіпсових виробів' },
  ],
  [OTHER_NONMETALLIC_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32791', label: 'Виробництво абразивних виробів' },
    { value: '327991', label: 'Різання каменю та виробництво кам’яних виробів' },
    {
      value: '327992',
      label: 'Виробництво подрібнених або оброблених мінералів і гірських порід',
    },
    { value: '327993', label: 'Виробництво мінеральної вати' },
    {
      value: '327999',
      label: 'Інше виробництво неметалевих мінеральних виробів',
    },
  ],
  [IRON_AND_STEEL_MILLS_INDUSTRY_GROUP]: [],
  [STEEL_PRODUCT_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '33121',
      label: 'Виробництво труб і трубок із чорних металів із придбаної сталі',
    },
    { value: '331221', label: 'Виробництво прокату сталевих профілів' },
    { value: '331222', label: 'Волочіння сталевого дроту' },
  ],
  [ALUMINA_AND_ALUMINUM_PRODUCTION_INDUSTRY_GROUP]: [
    {
      value: '331313',
      label: 'Переробка глинозему та виробництво первинного алюмінію',
    },
    {
      value: '331314',
      label: 'Вторинне плавлення та легування алюмінію',
    },
    {
      value: '331315',
      label: 'Виробництво алюмінієвих листів, плит і фольги',
    },
    {
      value: '331318',
      label: 'Інше прокатування, волочіння та пресування алюмінію',
    },
  ],
  [NONFERROUS_METAL_PRODUCTION_INDUSTRY_GROUP]: [
    {
      value: '33141',
      label: 'Плавлення та рафінування кольорових металів (крім алюмінію)',
    },
    {
      value: '33142',
      label: 'Прокатування, волочіння, пресування та легування міді',
    },
    {
      value: '331491',
      label: 'Прокатування, волочіння та пресування кольорових металів (крім міді та алюмінію)',
    },
    {
      value: '331492',
      label: 'Вторинне плавлення, рафінування та легування кольорових металів (крім міді та алюмінію)',
    },
  ],
  [FOUNDRIES_INDUSTRY_GROUP]: [
    { value: '331511', label: 'Ливарні заліза' },
    { value: '331512', label: 'Ливарні сталевих виробів за виплавлюваними моделями' },
    { value: '331513', label: 'Сталеливарні (крім за виплавлюваними моделями)' },
    { value: '331523', label: 'Ливарні кольорових металів під тиском' },
    { value: '331524', label: 'Ливарні алюмінію (крім лиття під тиском)' },
    {
      value: '331529',
      label: 'Інші ливарні кольорових металів (крім лиття під тиском)',
    },
  ],
  [FORGING_AND_STAMPING_INDUSTRY_GROUP]: [
    { value: '332111', label: 'Кування та штампування виробів із заліза й сталі' },
    { value: '332112', label: 'Кування виробів з кольорових металів' },
    { value: '332114', label: 'Виготовлення профілів методом роликового формування на замовлення' },
    { value: '332117', label: 'Виробництво деталей методом порошкової металургії' },
    {
      value: '332119',
      label:
        'Виробництво металевих кришок, закупорювальних виробів та іншого штампованого металу (крім автомобільного)',
    },
  ],
  [CUTLERY_AND_HANDTOOL_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '332215',
      label:
        'Виробництво металевого кухонного посуду, приладдя, столових приборів та ножів (крім виробів з дорогоцінних металів)',
    },
    { value: '332216', label: 'Виробництво пилкових полотен і ручних інструментів' },
  ],
  [ARCHITECTURAL_METALS_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '332311',
      label: 'Виробництво збірних металевих будівель та їх компонентів',
    },
    { value: '332312', label: 'Виробництво металевих будівельних конструкцій' },
    { value: '332313', label: 'Виробництво виробів із листового металу' },
    { value: '332321', label: 'Виробництво металевих вікон і дверей' },
    { value: '332322', label: 'Виготовлення виробів із листового металу' },
    {
      value: '332323',
      label: 'Виробництво декоративних та архітектурних металевих виробів',
    },
  ],
  [BOILERS_TANK_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '33241',
      label: 'Виробництво енергетичних котлів та теплообмінників',
    },
    {
      value: '33242',
      label: 'Виробництво металевих резервуарів (товстостінних)',
    },
    { value: '332431', label: 'Виробництво металевих банок' },
    { value: '332439', label: 'Виробництво іншої металевої тари' },
  ],
  [HARDWARE_MANUFACTURING_INDUSTRY_GROUP]: [],
  [SPRING_AND_WIRE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '332613', label: 'Виробництво пружин' },
    { value: '332618', label: 'Виробництво інших виробів із дроту' },
  ],
  [MACHINE_SHOPS_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33271', label: 'Металообробні цехи' },
    { value: '332721', label: 'Виробництво високоточних деталей токарної обробки' },
    {
      value: '332722',
      label: 'Виробництво болтів, гайок, гвинтів, заклепок і шайб',
    },
  ],
  [COATING_ENGRAVING_HEAT_TREATING_INDUSTRY_GROUP]: [
    { value: '332811', label: 'Термічна обробка металів' },
    {
      value: '332812',
      label: 'Покриття та гравірування металів (крім ювелірних і столових виробів) та інші послуги для виробників',
    },
    {
      value: '332813',
      label: 'Електролітичне покриття, нанесення покриттів, полірування, анодування та забарвлення металів',
    },
  ],
  [OTHER_FABRICATED_TOOL_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '332911', label: 'Виробництво промислових клапанів' },
    {
      value: '332912',
      label: 'Виробництво гідравлічних і пневматичних клапанів та з’єднувальних елементів',
    },
    {
      value: '332913',
      label: 'Виробництво арматури та комплектуючих для сантехнічних виробів',
    },
    {
      value: '332919',
      label: 'Виробництво інших металевих клапанів та трубних з’єднань',
    },
    { value: '332991', label: 'Виробництво кулькових і роликових підшипників' },
    { value: '332992', label: 'Виробництво боєприпасів до стрілецької зброї' },
    {
      value: '332993',
      label: 'Виробництво боєприпасів (крім боєприпасів до стрілецької зброї)',
    },
    {
      value: '332994',
      label: 'Виробництво стрілецької зброї, артилерійських систем та їх комплектуючих',
    },
    { value: '332996', label: 'Виробництво виготовлених труб і фасонних частин' },
    {
      value: '332999',
      label: 'Інше виробництво готових металевих виробів',
    },
  ],
  [AGRICULTURE_CONSTRUCTION_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '333111', label: 'Виробництво сільськогосподарської техніки та обладнання' },
    {
      value: '333112',
      label: 'Виробництво садово-паркових тракторів та обладнання для догляду за присадибними ділянками',
    },
    { value: '33312', label: 'Виробництво будівельної техніки' },
    { value: '333131', label: 'Виробництво гірничодобувного обладнання та техніки' },
    {
      value: '333132',
      label: 'Виробництво обладнання та техніки для нафтових і газових родовищ',
    },
  ],
  [INDUSTRIAL_MACHINERY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '333241', label: 'Виробництво обладнання для харчової промисловості' },
    { value: '333242', label: 'Виробництво обладнання для напівпровідникової промисловості' },
    {
      value: '333243',
      label: 'Виробництво лісопильного, деревообробного та паперового обладнання',
    },
    { value: '333248', label: 'Інше виробництво промислового обладнання' },
  ],
  [COMMERCIAL_AND_SERVICE_INDUSTRY_MANUFACTURING_INDUSTRY_GROUP]: [],
  [VENTILATION_HEATING_AIR_CONDITIONING_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '333413',
      label: 'Виробництво промислових та комерційних вентиляторів, повітродувок і обладнання для очищення повітря',
    },
    {
      value: '333414',
      label: 'Виробництво опалювального обладнання (крім повітряних опалювальних печей)',
    },
    {
      value: '333415',
      label:
        'Виробництво кондиціонерів, повітряних опалювальних систем та комерційного й промислового холодильного обладнання',
    },
  ],
  [METALWORKING_MACHINERY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '333511', label: 'Виробництво промислових прес-форм' },
    {
      value: '333514',
      label: 'Виробництво спеціальних штампів, прес-форм, кондукторів та пристроїв',
    },
    {
      value: '333515',
      label: 'Виробництво ріжучого інструменту та приладдя до верстатів',
    },
    { value: '333517', label: 'Виробництво верстатів' },
    {
      value: '333519',
      label: 'Виробництво обладнання прокатних станів та іншого металообробного обладнання',
    },
  ],
  [ENGINE_TURBINE_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '333611',
      label: 'Виробництво турбін та комплектів турбогенераторів',
    },
    {
      value: '333612',
      label: 'Виробництво редукторів, швидкісних промислових приводів та зубчастих передач',
    },
    {
      value: '333613',
      label: 'Виробництво обладнання для механічної передачі потужності',
    },
    { value: '333618', label: 'Виробництво іншого двигунного обладнання' },
  ],
  [OTHER_GENERAL_PURPOSE_MACHINERY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33391', label: 'Виробництво насосів і компресорів' },
    { value: '333912', label: 'Виробництво повітряних і газових компресорів' },
    {
      value: '333914',
      label: 'Виробництво вимірювальних, дозувальних та іншого насосного обладнання',
    },
    {
      value: '333921',
      label: 'Виробництво ліфтів і рухомих сходів',
    },
    {
      value: '333922',
      label: 'Виробництво конвеєрів та транспортуючого обладнання',
    },
    {
      value: '333923',
      label: 'Виробництво мостових кранів, тельферів та монорейкових систем',
    },
    {
      value: '333924',
      label: 'Виробництво промислових вантажних візків, тягачів, причепів та штабелювальної техніки',
    },
    { value: '333991', label: 'Виробництво механізованого ручного інструменту' },
    { value: '333992', label: 'Виробництво зварювального та паяльного обладнання' },
    { value: '333993', label: 'Виробництво пакувального обладнання' },
    {
      value: '333994',
      label: 'Виробництво промислових печей і термічного обладнання',
    },
    {
      value: '333995',
      label: 'Виробництво гідравлічних і пневматичних циліндрів та приводів',
    },
    {
      value: '333996',
      label: 'Виробництво гідравлічних і пневматичних насосів та моторів',
    },
    {
      value: '333998',
      label: 'Інше виробництво загальнопромислового обладнання',
    },
  ],
  [COMPUTER_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '334111', label: 'Виробництво електронних комп’ютерів' },
    { value: '334112', label: 'Виробництво пристроїв комп’ютерного зберігання даних' },
    {
      value: '334118',
      label: 'Виробництво комп’ютерних терміналів та іншого периферійного обладнання',
    },
  ],
  [COMMUNICATION_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33421', label: 'Виробництво телефонної апаратури' },
    {
      value: '33422',
      label: 'Виробництво обладнання для радіо- і телемовлення та бездротового зв’язку',
    },
    { value: '33429', label: 'Інше виробництво телекомунікаційного обладнання' },
  ],
  [AUDIO_VIDEO_MANUFACTURING_INDUSTRY_GROUP]: [],
  [SEMICONDUCTOR_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '334412',
      label: 'Виробництво незмонтованих друкованих плат',
    },
    {
      value: '334413',
      label: 'Виробництво напівпровідників та споріднених пристроїв',
    },
    {
      value: '334416',
      label: 'Виробництво конденсаторів, резисторів, котушок, трансформаторів та інших індуктивних елементів',
    },
    { value: '334417', label: 'Виробництво електронних з’єднувачів' },
    {
      value: '334418',
      label: 'Виробництво змонтованих друкованих плат (електронних модулів)',
    },
    { value: '334419', label: 'Інше виробництво електронних компонентів' },
  ],
  [NAVIGATIONAL_INSTRUMENTS_INDUSTRY_GROUP]: [
    {
      value: '334510',
      label: 'Виробництво електромедичної та електротерапевтичної апаратури',
    },
    {
      value: '334511',
      label: 'Виробництво систем і приладів для пошуку, виявлення, навігації, керування, авіації та мореплавства',
    },
    {
      value: '334512',
      label:
        'Виробництво обладнання автоматичного керування мікрокліматом у житлових, комерційних будівлях та побутовій техніці',
    },
    {
      value: '334513',
      label:
        'Виробництво приладів та пов’язаних виробів для вимірювання, відображення й контролю параметрів промислових процесів',
    },
    {
      value: '334514',
      label: 'Виробництво приладів для вимірювання об’ємної витрати рідин та лічильників',
    },
    {
      value: '334515',
      label: 'Виробництво приладів для вимірювання та тестування електрики й електричних сигналів',
    },
    { value: '334516', label: 'Виробництво аналітичних лабораторних приладів' },
    { value: '334517', label: 'Виробництво опромінювальної апаратури' },
    {
      value: '334519',
      label: 'Інше виробництво приладів для вимірювання та контролю',
    },
  ],
  [MANUFACTURING_AND_REPRODUCING_MAGNETIC_AND_OPTICAL_MEDIA_INDUSTRY_GROUP]: [],
  [ELECTRIC_LIGHTING_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '335131',
      label: 'Виробництво електросвітильників для житлових приміщень',
    },
    {
      value: '335132',
      label: 'Виробництво електросвітильників для комерційних, промислових та інституційних будівель',
    },
    {
      value: '335139',
      label: 'Виробництво електричних ламп та іншого освітлювального обладнання',
    },
  ],
  [HOUSEHOLD_APPLIANCE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33521', label: 'Виробництво дрібної електропобутової техніки' },
    { value: '33522', label: 'Виробництво великої побутової техніки' },
  ],
  [ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '335311',
      label: 'Виробництво силових, розподільчих та спеціальних трансформаторів',
    },
    { value: '335312', label: 'Виробництво електродвигунів і генераторів' },
    {
      value: '335313',
      label: 'Виробництво комутаційної та розподільчої апаратури',
    },
    { value: '335314', label: 'Виробництво реле та промислових систем керування' },
  ],
  [OTHER_ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33591', label: 'Виробництво батарей та акумуляторів' },
    { value: '335921', label: 'Виробництво волоконно-оптичних кабелів' },
    {
      value: '335929',
      label: 'Виробництво інших кабелів зв’язку та силових кабелів',
    },
    { value: '33593', label: 'Виробництво електромонтажних виробів' },
    { value: '335991', label: 'Виробництво виробів з вуглецю та графіту' },
    {
      value: '335999',
      label: 'Інше виробництво електрообладнання та електричних компонентів',
    },
  ],
  [MOTOR_VEHICLE_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '33611',
      label: 'Виробництво легкових автомобілів та легкого автомобільного транспорту',
    },
    { value: '33612', label: 'Виробництво важких вантажних автомобілів' },
  ],
  [VEHICLE_BODY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '336211', label: 'Виробництво кузовів автотранспортних засобів' },
    { value: '336212', label: 'Виробництво причепів для вантажних автомобілів' },
    { value: '336213', label: 'Виробництво будинків-автопричепів (кемперів)' },
    { value: '336214', label: 'Виробництво туристичних причепів та кемперів' },
  ],
  [VEHICLE_PARTS_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '33631',
      label: 'Виробництво бензинових двигунів для автомобілів та їхніх частин',
    },
    {
      value: '33632',
      label: 'Виробництво електричного та електронного обладнання для автомобілів',
    },
    {
      value: '33633',
      label: 'Виробництво рульових систем та деталей підвіски автомобілів (крім пружин)',
    },
    { value: '33634', label: 'Виробництво гальмівних систем для автомобілів' },
    {
      value: '33635',
      label: 'Виробництво коробок передач та елементів трансмісії автомобілів',
    },
    {
      value: '33636',
      label: 'Виробництво сидінь та інтер’єрної обробки автомобілів',
    },
    { value: '33637', label: 'Штампування металевих деталей для автомобілів' },
    { value: '33639', label: 'Інше виробництво автокомплектуючих' },
  ],
  [AEROSPACE_PRODUCT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '336411', label: 'Виробництво літаків' },
    {
      value: '336412',
      label: 'Виробництво авіадвигунів та їхніх частин',
    },
    {
      value: '336413',
      label: 'Виробництво інших авіаційних частин та допоміжного обладнання',
    },
    { value: '336414', label: 'Виробництво керованих ракет і космічних апаратів' },
    {
      value: '336415',
      label: 'Виробництво силових установок та вузлів силових установок для керованих ракет і космічних апаратів',
    },
    {
      value: '336419',
      label: 'Виробництво інших частин та допоміжного обладнання для керованих ракет і космічних апаратів',
    },
  ],
  [RAILROAD_MANUFACTURING_INDUSTRY_GROUP]: [],
  [SHIP_AND_BOAT_BUILDING_INDUSTRY_GROUP]: [
    { value: '336611', label: 'Будівництво та ремонт суден' },
    { value: '336612', label: 'Будівництво човнів' },
  ],
  [OTHER_TRANSPORTATION_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '336991',
      label: 'Виробництво мотоциклів, велосипедів та їхніх частин',
    },
    {
      value: '336992',
      label: 'Виробництво військових броньованих машин, танків та їх комплектуючих',
    },
    {
      value: '336999',
      label: 'Інше виробництво транспортного обладнання',
    },
  ],
  [HOUSEHOLD_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '33711',
      label: 'Виробництво дерев’яних кухонних меблів та стільниць',
    },
    {
      value: '337121',
      label: 'Виробництво м’яких меблів для дому',
    },
    {
      value: '337122',
      label: 'Виробництво дерев’яних нем’яких меблів для дому',
    },
    {
      value: '337126',
      label: 'Виробництво домашніх меблів (крім дерев’яних і м’яких)',
    },
    { value: '337127', label: 'Виробництво меблів для установ та закладів' },
  ],
  [OFFICE_FURNITURE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '337211', label: 'Виробництво дерев’яних офісних меблів' },
    {
      value: '337212',
      label: 'Виробництво індивідуальних архітектурних виробів з дерева та столярних виробів',
    },
    { value: '337214', label: 'Виробництво офісних меблів (крім дерев’яних)' },
    {
      value: '337215',
      label: 'Виробництво вітрин, перегородок, стелажів та шаф-локерів',
    },
  ],
  [OTHER_FURNITURE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33791', label: 'Виробництво матраців' },
    { value: '33792', label: 'Виробництво жалюзі та штор' },
  ],
  [MEDICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '339112',
      label: 'Виробництво хірургічних та медичних інструментів',
    },
    {
      value: '339113',
      label: 'Виробництво хірургічних виробів та медичних приладів',
    },
    { value: '339114', label: 'Виробництво стоматологічного обладнання та приладдя' },
    { value: '339115', label: 'Виробництво оптичних товарів для офтальмології' },
    { value: '339116', label: 'Стоматологічні лабораторії' },
  ],
  [OTHER_MISCELLANEOUS_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33991', label: 'Виробництво ювелірних виробів та виробів зі срібла' },
    { value: '33992', label: 'Виробництво спортивних та атлетичних товарів' },
    { value: '33993', label: 'Виробництво ляльок, іграшок та ігор' },
    {
      value: '33994',
      label: 'Виробництво офісного приладдя (крім паперових виробів)',
    },
    { value: '33995', label: 'Виробництво вивісок та знаків' },
    {
      value: '339991',
      label: 'Виробництво ущільнювачів, прокладок і герметизувальних виробів',
    },
    { value: '339992', label: 'Виробництво музичних інструментів' },
    {
      value: '339993',
      label: 'Виробництво застібок, ґудзиків, голок і шпильок',
    },
    { value: '339994', label: 'Виробництво щіток, мітел та швабр' },
    { value: '339995', label: 'Виробництво трун' },
    { value: '339999', label: 'Інше різноманітне виробництво' },
  ],
  [PRINTING_MANUFACTURING_SUB_SECTOR]: [
    {
      value: '323111',
      label: 'Комерційний друк (крім трафаретного друку та друку книг)',
    },
    { value: '323113', label: 'Комерційний трафаретний (шовкотрафаретний) друк' },
    { value: '323117', label: 'Друк книг' },
    { value: '32312', label: 'Допоміжна діяльність у сфері друку' },
  ],
  [PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR]: [
    { value: '32411', label: 'Нафтопереробні заводи' },
    {
      value: '324121',
      label: 'Виробництво асфальтобетонних сумішей та блоків',
    },
    {
      value: '324122',
      label: 'Виробництво бітумної черепиці та покрівельних і ізоляційних матеріалів на основі бітуму',
    },
    {
      value: '324191',
      label: 'Виробництво мастильних олив і мастил на нафтовій основі',
    },
    {
      value: '324199',
      label: 'Інше виробництво нафтопродуктів і продуктів з вугілля',
    },
  ],
  [PROF_AND_COMMERCIAL_EQUIPMENT_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42341', label: 'Оптові торговці фотографічним обладнанням та приладдям' },
    { value: '42342', label: 'Оптові торговці офісним обладнанням' },
    {
      value: '42343',
      label: 'Оптові торговці комп’ютерами, периферійним обладнанням та програмним забезпеченням',
    },
    { value: '42344', label: 'Оптові торговці іншим комерційним обладнанням' },
    {
      value: '42345',
      label: 'Оптові торговці медичним, стоматологічним та лікарняним обладнанням і приладдям',
    },
    { value: '42346', label: 'Оптові торговці офтальмологічними товарами' },
    { value: '42349', label: 'Оптові торговці іншим професійним обладнанням та приладдям' },
  ],
  [METAL_AND_MINERAL_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42351',
      label: 'Металосервісні центри та інші оптові торговці металом',
    },
    {
      value: '42352',
      label: 'Оптові торговці вугіллям, іншими мінералами та рудами',
    },
  ],
  [HOUSEHOLD_APPLIANCES_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42361',
      label: 'Оптові торговці електротехнічними виробами, кабельно-провідниковою продукцією та супутнім обладнанням',
    },
    {
      value: '42362',
      label: 'Оптові торговці побутовою технікою, електротоварами для дому та споживчою електронікою',
    },
    { value: '42369', label: 'Оптові торговці іншими електронними компонентами та обладнанням' },
  ],
  [HARDWARE_AND_PLUMBING_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42371',
      label: 'Оптові торговці будівельною фурнітурою, інструментом та господарськими товарами',
    },
    {
      value: '42372',
      label: 'Оптові торговці сантехнічним і теплотехнічним обладнанням та приладдям (гідроніка)',
    },
    {
      value: '42373',
      label: 'Оптові торговці обладнанням і приладдям для повітряного опалення та кондиціювання',
    },
    { value: '42374', label: 'Оптові торговці холодильним обладнанням та приладдям' },
  ],
  [MACHINERY_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42381',
      label: 'Оптові торговці будівельною та гірничодобувною технікою й обладнанням (крім буріння нафтових свердловин)',
    },
    {
      value: '42382',
      label: 'Оптові торговці сільськогосподарською та садово-парковою технікою й обладнанням',
    },
    { value: '42383', label: 'Оптові торговці промисловим обладнанням і машинами' },
    { value: '42384', label: 'Оптові торговці промисловими витратними матеріалами та приладдям' },
    {
      value: '42385',
      label: 'Оптові торговці обладнанням і приладдям для підприємств сфери послуг',
    },
    {
      value: '42386',
      label: 'Оптові торговці транспортним обладнанням та приладдям (крім автотранспортних засобів)',
    },
  ],
  [MISCELLANEOUS_DURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42391',
      label: 'Оптові торговці спортивними та рекреаційними товарами і приладдям',
    },
    {
      value: '42392',
      label: 'Оптові торговці іграшками, товарами для хобі та приладдям',
    },
    { value: '42393', label: 'Оптові торговці вторинною сировиною' },
    {
      value: '42394',
      label: 'Оптові торговці ювелірними виробами, годинниками, дорогоцінним камінням та металами',
    },
    {
      value: '42399',
      label: 'Оптові торговці іншими різноманітними товарами тривалого користування',
    },
  ],
  [PAPER_AND_PRODUCT_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42411', label: 'Оптові торговці папером для друку та письма' },
    { value: '42412', label: 'Оптові торговці канцелярськими та офісними товарами' },
    {
      value: '42413',
      label: 'Оптові торговці промисловим та санітарно-гігієнічним папером',
    },
  ],
  [DRUGS_WHOLESALERS_INDUSTRY_GROUP]: [],
  [APPAREL_PIECE_GOODS_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42431',
      label: 'Оптові торговці тканинами, галантереєю та іншими швейними товарами',
    },
    { value: '42434', label: 'Оптові торговці взуттям' },
    { value: '42435', label: 'Оптові торговці одягом та аксесуарами' },
  ],
  [GROCERY_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42441',
      label: 'Оптові торговці широким асортиментом продовольчих товарів',
    },
    { value: '42442', label: 'Оптові торговці фасованими замороженими продуктами' },
    {
      value: '42443',
      label: 'Оптові торговці молочною продукцією (крім сухої та консервованої)',
    },
    {
      value: '42444',
      label: 'Оптові торговці м’ясом птиці та продуктами з нього',
    },
    { value: '42445', label: 'Оптові торговці кондитерськими виробами' },
    { value: '42446', label: 'Оптові торговці рибою та морепродуктами' },
    { value: '42447', label: 'Оптові торговці м’ясом та м’ясопродуктами' },
    { value: '42448', label: 'Оптові торговці свіжими фруктами та овочами' },
    {
      value: '42449',
      label: 'Оптові торговці іншими продовольчими товарами та супутньою продукцією',
    },
  ],
  [FARM_PRODUCT_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42451', label: 'Оптові торговці зерновими та квасолею' },
    { value: '42452', label: 'Оптові торговці живою худобою' },
    { value: '42459', label: 'Оптові торговці іншою сільськогосподарською сировиною' },
  ],
  [CHEMICAL_AND_ALLIED_PRODUCTS_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42461',
      label: 'Оптові торговці пластиковою сировиною, заготовками та напівфабрикатами',
    },
    {
      value: '42469',
      label: 'Оптові торговці іншою хімічною продукцією та спорідненими товарами',
    },
  ],
  [PETROLEUM_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42471', label: 'Нафтові бази та оптові термінали нафтопродуктів' },
    {
      value: '42472',
      label: 'Оптові торговці нафтою та нафтопродуктами (крім баз і терміналів)',
    },
  ],
  [BEER_WINE_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42481', label: 'Оптові торговці пивом та елем' },
    {
      value: '42482',
      label: 'Оптові торговці винами та міцними алкогольними напоями',
    },
  ],
  [MISCELLANEOUS_NONDURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42491',
      label: 'Оптові торговці сільськогосподарськими товарами для виробників',
    },
    {
      value: '42492',
      label: 'Оптові торговці книгами, періодикою та газетами',
    },
    {
      value: '42493',
      label: 'Оптові торговці квітами, садивним матеріалом та товарами для флористів',
    },
    {
      value: '42494',
      label: 'Оптові торговці тютюновими виробами та електронними сигаретами',
    },
    {
      value: '42495',
      label: 'Оптові торговці фарбами, лаками та супутніми матеріалами',
    },
    {
      value: '42499',
      label: 'Оптові торговці іншими різноманітними товарами короткострокового користування',
    },
  ],
  [AGENTS_AND_BROKERS_SUB_SECTOR]: [],
  [AUTO_DEALERS_INDUSTRY_GROUP]: [
    { value: '44111', label: 'Дилери нових автомобілів' },
    { value: '44112', label: 'Дилери вживаних автомобілів' },
  ],
  [OTHER_MOTOR_DEALERS_INDUSTRY_GROUP]: [
    {
      value: '44121',
      label: 'Дилери автодомів та рекреаційних транспортних засобів',
    },
    { value: '441222', label: 'Дилери човнів та катерів' },
    {
      value: '441227',
      label: 'Дилери мотоциклів, квадроциклів та іншого мототранспорту',
    },
  ],
  [AUTOMOTIVE_PARTS_INDUSTRY_GROUP]: [
    { value: '44133', label: 'Магазини автозапчастин та аксесуарів' },
    { value: '44134', label: 'Дилери шин' },
  ],
  [BUILDING_MATERIAL_AND_SUPPLIES_DEALERS_INDUSTRY_GROUP]: [
    {
      value: '44411',
      label: 'Будівельно-господарські гіпермаркети (home centers)',
    },
    { value: '44412', label: 'Магазини фарб та шпалер' },
    {
      value: '44414',
      label: 'Магазини будівельної фурнітури та інструменту',
    },
    { value: '44418', label: 'Інші продавці будівельних матеріалів' },
  ],
  [LAWN_AND_GARDEN_EQUIPMENT_INDUSTRY_GROUP]: [
    {
      value: '44423',
      label: 'Магазини садово-паркової та іншої зовнішньої техніки',
    },
    {
      value: '44424',
      label: 'Садові центри та магазини товарів для фермерів',
    },
  ],
  [GROCERY_RETAILERS_INDUSTRY_GROUP]: [
    {
      value: '44511',
      label: 'Супермаркети та інші продуктові магазини (крім магазинів біля дому)',
    },
    { value: '445131', label: 'Магазини біля дому (convenience stores)' },
    { value: '445132', label: 'Оператори торгових автоматів' },
  ],
  [SPECIALTY_FOOD_RETAILERS_INDUSTRY_GROUP]: [
    { value: '44523', label: 'Магазини фруктів та овочів' },
    { value: '44524', label: 'М’ясні магазини' },
    { value: '44525', label: 'Рибні магазини та морепродукти' },
    { value: '445291', label: 'Магазини хлібобулочних виробів' },
    {
      value: '445292',
      label: 'Магазини кондитерських виробів та горіхів',
    },
    { value: '445298', label: 'Інші спеціалізовані магазини харчових продуктів' },
  ],
  [BEER_WINE_LIQUOR_RETAILERS_INDUSTRY_GROUP]: [],
  [FURNITURE_RETAILERS_INDUSTRY_GROUP]: [
    { value: '44911', label: 'Магазини меблів' },
    { value: '449121', label: 'Магазини підлогових покриттів' },
    {
      value: '449122',
      label: 'Магазини сонцезахисних та віконних декорів (жалюзі, штори тощо)',
    },
    {
      value: '449129',
      label: 'Інші магазини товарів для дому та інтер’єру',
    },
  ],
  [ELECTRONICS_RETAILERS_INDUSTRY_GROUP]: [],
  [DEPARTMENT_STORE_INDUSTRY_GROUP]: [],
  [WAREHOUSE_CLUBS_RETAILERS_INDUSTRY_GROUP]: [
    {
      value: '455211',
      label: 'Оптові клуби та супермаркети-гіпермаркети',
    },
    {
      value: '455219',
      label: 'Інші роздрібні продавці широкого асортименту товарів',
    },
  ],
  [HEALTH_RETAILERS_SUB_SECTOR]: [
    { value: '45611', label: 'Аптеки та магазини лікарських засобів' },
    {
      value: '45612',
      label: 'Магазини косметики, товарів для краси та парфумерії',
    },
    { value: '45613', label: 'Магазини оптики та оптичних товарів' },
    { value: '456191', label: 'Магазини харчових (оздоровчих) добавок' },
    {
      value: '456199',
      label: 'Інші магазини товарів для здоров’я та особистої гігієни',
    },
  ],
  [GASOLINE_STATIONS_INDUSTRY_GROUP]: [
    {
      value: '45711',
      label: 'АЗС з магазинами біля дороги',
    },
    { value: '45712', label: 'Інші автозаправні станції' },
  ],
  [FUEL_DEALERS_INDUSTRY_GROUP]: [],
  [CLOTHING_RETAILERS_INDUSTRY_GROUP]: [],
  [SHOE_RETAILERS_INDUSTRY_GROUP]: [],
  [JEWELRY_RETAILERS_INDUSTRY_GROUP]: [
    { value: '45831', label: 'Ювелірні магазини' },
    { value: '45832', label: 'Магазини валіз та шкіряних виробів' },
  ],
  [SPORTING_GOODS_RETAILERS_INDUSTRY_GROUP]: [
    { value: '45911', label: 'Магазини спортивних товарів' },
    {
      value: '45912',
      label: 'Магазини товарів для хобі, іграшок та ігор',
    },
    {
      value: '45913',
      label: 'Магазини товарів для шиття, рукоділля та тканин',
    },
    {
      value: '45914',
      label: 'Магазини музичних інструментів та приладдя',
    },
  ],
  [BOOK_RETAILERS_INDUSTRY_GROUP]: [],
  [FLORISTS_INDUSTRY_GROUP]: [],
  [OFFICE_SUPPLY_RETAILERS_INDUSTRY_GROUP]: [
    {
      value: '45941',
      label: 'Магазини офісних товарів та канцелярії',
    },
    {
      value: '45942',
      label: 'Магазини подарунків, сувенірів та оригінальних товарів',
    },
  ],
  [USED_MERCHANDISE_INDUSTRY_GROUP]: [],
  [OTHER_MISCELLANEOUS_INDUSTRY_GROUP]: [
    {
      value: '45991',
      label: 'Магазини зоотоварів та товарів для домашніх тварин',
    },
    { value: '45992', label: 'Галереї та дилери творів мистецтва' },
    {
      value: '45993',
      label: 'Дилери збірних (мобільних) будинків',
    },
    {
      value: '45999',
      label: 'Інші різноманітні роздрібні продавці',
    },
    {
      value: '459991',
      label: 'Магазини тютюнових виробів, електронних сигарет та інших товарів для куріння',
    },
  ],
  [SCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '481111', label: 'Регулярні пасажирські авіаперевезення' },
    { value: '481112', label: 'Регулярні вантажні авіаперевезення' },
  ],
  [NONSCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP]: [
    {
      value: '481211',
      label: 'Чартерні пасажирські авіаперевезення (нерегулярні)',
    },
    {
      value: '481212',
      label: 'Чартерні вантажні авіаперевезення (нерегулярні)',
    },
    { value: '481219', label: 'Інші нерегулярні авіаперевезення' },
  ],
  [DEEP_SEA_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '483111', label: 'Міжконтинентальні морські вантажні перевезення' },
    { value: '483112', label: 'Міжконтинентальні морські пасажирські перевезення' },
    {
      value: '483113',
      label: 'Прибережні та озерні вантажні перевезення',
    },
    {
      value: '483114',
      label: 'Прибережні та озерні пасажирські перевезення',
    },
  ],
  [INLAND_WATER_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '483211', label: 'Внутрішні водні вантажні перевезення' },
    { value: '483212', label: 'Внутрішні водні пасажирські перевезення' },
  ],
  [GENERAL_FREIGHT_TRUCKING_INDUSTRY_GROUP]: [
    {
      value: '48411',
      label: 'Місцеві вантажні автомобільні перевезення загальних вантажів',
    },
    {
      value: '484121',
      label: 'Міжміські вантажні перевезення повними автомобільними партіями (truckload)',
    },
    {
      value: '484122',
      label: 'Міжміські вантажні перевезення збірних вантажів (less-than-truckload)',
    },
  ],
  [SPECIALIZED_FREIGHT_TRUCKING_INDUSTRY_GROUP]: [
    {
      value: '48421',
      label: 'Перевезення вживаних домашніх речей та офісного майна (мувінг)',
    },
    {
      value: '48422',
      label: 'Місцеві перевезення спеціалізованих вантажів (крім вживаних речей)',
    },
    {
      value: '48423',
      label: 'Міжміські перевезення спеціалізованих вантажів (крім вживаних речей)',
    },
  ],
  [URBAN_TRANSIT_SYSTEMS_INDUSTRY_GROUP]: [
    {
      value: '485111',
      label: 'Міські системи громадського транспорту змішаних видів',
    },
    { value: '485112', label: 'Приміські залізничні системи' },
    {
      value: '485113',
      label: 'Автобусні та інші моторизовані міські транспортні системи',
    },
    { value: '485119', label: 'Інші міські транспортні системи' },
  ],
  [INTERURBAN_TRANSPORTATION_INDUSTRY_GROUP]: [],
  [TAXI_SERVICE_INDUSTRY_GROUP]: [
    {
      value: '48531',
      label: 'Служби таксі та спільних поїздок (ridesharing)',
    },
    { value: '48532', label: 'Лімузин-сервіси' },
  ],
  [SCHOOL_TRANSPORTATION_INDUSTRY_GROUP]: [],
  [CHARTER_BUS_INDUSTRY_GROUP]: [],
  [OTHER_TRANSIT_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '485991', label: 'Перевезення пасажирів з особливими потребами' },
    {
      value: '485999',
      label: 'Інші види пасажирських наземних та маршрутних перевезень',
    },
  ],
  [CRUDE_OIL_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP]: [],
  [NATURAL_GAS_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP]: [],
  [OTHER_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP]: [
    {
      value: '48691',
      label: 'Трубопровідний транспорт нафтопродуктів глибокої переробки',
    },
    { value: '48699', label: 'Інші види трубопровідного транспорту' },
  ],
  [SCENIC_LAND_INDUSTRY_GROUP]: [],
  [SCENIC_WATER_INDUSTRY_GROUP]: [],
  [SCENIC_OTHER_INDUSTRY_GROUP]: [],
  [SUPPORT_FOR_AIR_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '48811', label: 'Експлуатація аеропортів' },
    { value: '488111', label: 'Управління повітряним рухом' },
    { value: '488119', label: 'Інші види діяльності з обслуговування аеропортів' },
    {
      value: '48819',
      label: 'Інша допоміжна діяльність у сфері авіаційного транспорту',
    },
  ],
  [SUPPORT_FOR_RAIL_TRANSPORTATION_INDUSTRY_GROUP]: [],
  [SUPPORT_FOR_WATER_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '48831', label: 'Експлуатація морських портів і гаваней' },
    { value: '48832', label: 'Переробка вантажів у морських портах' },
    { value: '48833', label: 'Навігаційні послуги для морського судноплавства' },
    {
      value: '48839',
      label: 'Інша допоміжна діяльність у сфері водного транспорту',
    },
  ],
  [SUPPORT_FOR_ROAD_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '48841', label: 'Евакуація та буксирування автотранспортних засобів' },
    {
      value: '48849',
      label: 'Інша допоміжна діяльність у сфері автомобільного транспорту',
    },
  ],
  [FREIGHT_TRANSPORTATION_AGREEMENT_INDUSTRY_GROUP]: [],
  [OTHER_SUPPORT_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '488991', label: 'Пакування та ящування вантажів' },
    {
      value: '488999',
      label: 'Інша допоміжна діяльність у сфері транспорту',
    },
  ],
  [COURIER_DELIVERY_INDUSTRY_GROUP]: [],
  [LOCAL_DELIVERY_INDUSTRY_GROUP]: [],
  [MOTION_PICTURE_INDUSTRY_GROUP]: [
    { value: '51211', label: 'Виробництво кіно- та відеофільмів' },
    { value: '51212', label: 'Дистрибуція кіно- та відеопродукції' },
    { value: '51213', label: 'Прокат і показ кінофільмів' },
    {
      value: '51219',
      label: 'Постпродакшн-послуги та інша діяльність у сфері кіно і відео',
    },
    { value: '512191', label: 'Телепродакшн та інші послуги постпродакшну' },
    {
      value: '512199',
      label: 'Інша діяльність у сфері кіно- та відеоіндустрії',
    },
  ],
  [SOUND_INDUSTRY_GROUP]: [
    { value: '51223', label: 'Музичні видавництва' },
    { value: '51224', label: 'Студії звукозапису' },
    { value: '51225', label: 'Виробництво та дистрибуція музичних записів' },
    { value: '51229', label: 'Інша діяльність у сфері звукозапису' },
  ],
  [NEWSPAPER_INDUSTRY_GROUP]: [
    { value: '51311', label: 'Видавництва газет' },
    { value: '51312', label: 'Видавництва періодичних видань' },
    { value: '51313', label: 'Книжкові видавництва' },
    {
      value: '51314',
      label: 'Видавництва довідників та баз розсилок',
    },
    { value: '513191', label: 'Видавництва вітальних листівок' },
    { value: '513199', label: 'Інші видавництва' },
  ],
  [SOFTWARE_PUBLISHERS_INDUSTRY_GROUP]: [],
  [RADIO_AND_TELEVISION_INDUSTRY_GROUP]: [
    { value: '51611', label: 'Радіомовні станції' },
    { value: '51612', label: 'Телевізійні мовні станції' },
  ],
  [MEDIA_STREAMING_INDUSTRY_GROUP]: [],
  [WIRED_TELECOMMUNICATIONS_INDUSTRY_GROUP]: [
    { value: '517111', label: 'Провайдери фіксованого (проводового) зв’язку' },
    {
      value: '517112',
      label: 'Оператори бездротового стільникового зв’язку (крім супутникового)',
    },
    { value: '517121', label: 'Реселери телекомунікаційних послуг' },
    {
      value: '517122',
      label: 'Агенти з продажу послуг бездротового зв’язку',
    },
  ],
  [SATELLITE_TELECOMMUNICATIONS_INDUSTRY_GROUP]: [],
  [OTHER_TELECOMMUNICATIONS_INDUSTRY_GROUP]: [],
  [DEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP]: [
    { value: '52211', label: 'Комерційні банки' },
    { value: '52213', label: 'Кредитні спілки' },
    {
      value: '52218',
      label: 'Ощадні установи та інші депозитні кредитні посередники',
    },
  ],
  [NONDEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP]: [
    { value: '52221', label: 'Випуск кредитних карток' },
    { value: '52222', label: 'Фінансування продажів' },
    { value: '522291', label: 'Споживче кредитування' },
    { value: '522292', label: 'Кредитування під нерухомість' },
    {
      value: '522299',
      label: 'Міжнародне, вторинне та інше недепозитне кредитне посередництво',
    },
  ],
  [ACTIVITIES_RELATED_TO_CREDIT_INTERMEDIATION_INDUSTRY_GROUP]: [
    {
      value: '52231',
      label: 'Брокери і посередники з іпотечного та неіпотечного кредитування',
    },
    {
      value: '52232',
      label: 'Обробка фінансових транзакцій, розрахунки та клірингова діяльність',
    },
    {
      value: '52239',
      label: 'Інша діяльність, пов’язана з кредитним посередництвом',
    },
  ],
  [COMMODITY_CONTRACTS_INDUSTRY_GROUP]: [
    {
      value: '52315',
      label: 'Інвестиційні банки та посередництво з цінними паперами',
    },
    {
      value: '52316',
      label: 'Посередництво з товарними деривативами та контрактами',
    },
  ],
  [COMMODITY_EXCHANGES_INDUSTRY_GROUP]: [],
  [OTHER_FINANCIAL_INVESTMENT_ACTIVITIES_INDUSTRY_GROUP]: [
    { value: '52391', label: 'Інше фінансове посередництво' },
    {
      value: '52394',
      label: 'Управління інвестиційними портфелями та інвестиційні консультації',
    },
    {
      value: '523991',
      label: 'Трастова, фідуціарна та депозитарна діяльність',
    },
    {
      value: '523999',
      label: 'Інша діяльність у сфері фінансових інвестицій',
    },
  ],
  [INSURANCE_CARRIER_INDUSTRY_GROUP]: [
    {
      value: '52411',
      label: 'Страхові компанії з особистого страхування життя, здоров’я та медичного страхування',
    },
    {
      value: '524126',
      label: 'Страхові компанії з майнового страхування та страхування відповідальності',
    },
    { value: '524127', label: 'Страхові компанії з титульного страхування' },
    {
      value: '524128',
      label: 'Інші прямі страхові компанії (крім страхування життя, здоров’я та медичного страхування)',
    },
    { value: '52413', label: 'Перестрахові компанії' },
  ],
  [AGENCIES_BROKERAGES_INDUSTRY_GROUP]: [
    { value: '52421', label: 'Страхові агентства та брокерські компанії' },
    { value: '524291', label: 'Оцінка та врегулювання страхових збитків' },
    {
      value: '524292',
      label:
        'Керування фармацевтичними програмами пільг та інше адміністрування страхових і пенсійних фондів третіми сторонами',
    },
    {
      value: '524298',
      label: 'Інша діяльність, пов’язана зі страхуванням',
    },
  ],
  [INSURANCE_FUNDS_INDUSTRY_GROUP]: [
    { value: '52511', label: 'Пенсійні фонди' },
    { value: '52512', label: 'Фонди медичного та соціального забезпечення' },
    { value: '52519', label: 'Інші страхові фонди' },
  ],
  [OTHER_FUNDS_FUNDS_INDUSTRY_GROUP]: [
    {
      value: '52591',
      label: 'Взаємні (пайові) інвестиційні фонди відкритого типу',
    },
    {
      value: '52592',
      label: 'Трасти, спадкові фонди та агентські рахунки',
    },
    { value: '52599', label: 'Інші фінансові інструменти колективного інвестування' },
  ],
  [LESSORS_OF_REAL_ESTATE_INDUSTRY_GROUP]: [
    {
      value: '53111',
      label: 'Орендодавці житлових будівель та приміщень',
    },
    {
      value: '53112',
      label: 'Орендодавці нежитлових будівель (крім мінісховищ)',
    },
    {
      value: '53113',
      label: 'Орендодавці мінісховищ та приміщень самоcкладування',
    },
    { value: '53119', label: 'Орендодавці іншого нерухомого майна' },
  ],
  [OFFICES_OF_REAL_ESTATE_INDUSTRY_GROUP]: [],
  [ACTIVITIES_RELATED_TO_REAL_ESTATE_INDUSTRY_GROUP]: [
    { value: '53131', label: 'Управителі об’єктів нерухомості' },
    { value: '53132', label: 'Офіси оцінювачів нерухомості' },
    {
      value: '53139',
      label: 'Інша діяльність, пов’язана з нерухомістю',
    },
  ],
  [AUTOMOTIVE_LEASING_INDUSTRY_GROUP]: [
    {
      value: '53211',
      label: 'Оренда та лізинг легкових автомобілів',
    },
    {
      value: '53212',
      label: 'Оренда та лізинг вантажівок, причепів та автодомів (RV)',
    },
  ],
  [CONSUMER_GOODS_RENTAL_INDUSTRY_GROUP]: [
    {
      value: '53221',
      label: 'Оренда побутової техніки та споживчої електроніки',
    },
    { value: '532281', label: 'Оренда святкового одягу та костюмів' },
    { value: '532282', label: 'Оренда відеокасет та дисків' },
    { value: '532283', label: 'Оренда домашнього медичного обладнання' },
    { value: '532284', label: 'Оренда товарів для відпочинку та дозвілля' },
    { value: '532289', label: 'Оренда інших споживчих товарів' },
  ],
  [GENERAL_RENTAL_CENTERS_INDUSTRY_GROUP]: [],

  [COMMERCIAL_MACHINERY_INDUSTRY_GROUP]: [
    {
      value: '532411',
      label: 'Оренда та лізинг комерційного обладнання для авіаційного, залізничного та водного транспорту',
    },
    {
      value: '532412',
      label: 'Оренда та лізинг будівельної, гірничодобувної та лісогосподарської техніки й обладнання',
    },
    { value: '53242', label: 'Оренда та лізинг офісної техніки й обладнання' },
    {
      value: '53249',
      label: 'Оренда та лізинг іншої комерційної та промислової техніки й обладнання',
    },
  ],
  [LEGAL_SERVICES_INDUSTRY_GROUP]: [
    { value: '54111', label: 'Адвокатські та юридичні офіси' },
    { value: '54112', label: 'Нотаріальні контори' },
    {
      value: '541191',
      label: 'Бюро з оформлення прав власності та розрахунків за угодами з нерухомістю',
    },
    { value: '541199', label: 'Інші види юридичних послуг' },
  ],
  [ACCOUNTING_SERVICES_INDUSTRY_GROUP]: [
    {
      value: '541211',
      label: 'Офіси сертифікованих бухгалтерів та аудиторів',
    },
    { value: '541213', label: 'Послуги з підготовки та заповнення податкових декларацій' },
    { value: '541214', label: 'Послуги з нарахування заробітної плати (payroll)' },
    { value: '541219', label: 'Інші бухгалтерські послуги' },
  ],
  [ARCHITECTURAL_SERVICES_INDUSTRY_GROUP]: [
    { value: '54131', label: 'Архітектурні послуги' },
    { value: '54132', label: 'Ландшафтна архітектура' },
    { value: '54133', label: 'Інжинірингові та інженерні послуги' },
    { value: '54134', label: 'Послуги з креслення та проєктування' },
    { value: '54135', label: 'Послуги з інспекції та перевірки будівель' },
    {
      value: '54136',
      label: 'Геофізичні дослідження та картографічні роботи',
    },
    {
      value: '54137',
      label: 'Геодезичні роботи та картографування (крім геофізичних)',
    },
    { value: '54138', label: 'Випробувальні лабораторії та пов’язані послуги' },
  ],
  [DESIGN_SERVICES_INDUSTRY_GROUP]: [
    { value: '54141', label: 'Послуги з дизайну інтер’єру' },
    { value: '54142', label: 'Промисловий дизайн' },
    { value: '54143', label: 'Графічний дизайн' },
    { value: '54149', label: 'Інші спеціалізовані дизайнерські послуги' },
  ],
  [COMPUTER_SYSTEMS_DESIGN_SERVICES_INDUSTRY_GROUP]: [
    { value: '541511', label: 'Індивідуальна розробка програмного забезпечення' },
    { value: '541512', label: 'Проєктування та розробка комп’ютерних систем' },
    {
      value: '541513',
      label: 'Послуги з управління та аутсорсингу ІТ-інфраструктури',
    },
    { value: '541519', label: 'Інші послуги у сфері інформаційних технологій' },
  ],
  [TECHNICAL_CONSULTING_SERVICES_INDUSTRY_GROUP]: [
    {
      value: '541611',
      label: 'Консультаційні послуги з адміністративного та загального менеджменту',
    },
    { value: '541612', label: 'HR-консалтинг та управління персоналом' },
    { value: '541613', label: 'Маркетинговий консалтинг' },
    {
      value: '541614',
      label: 'Консалтинг з процесів, дистрибуції та логістики',
    },
    { value: '541618', label: 'Інші послуги з управлінського консалтингу' },
    { value: '54162', label: 'Екологічний консалтинг' },
    {
      value: '54169',
      label: 'Інші наукові та технічні консультаційні послуги',
    },
  ],
  [SCIENTIFIC_RESEARCH_SERVICES_INDUSTRY_GROUP]: [
    {
      value: '541713',
      label: 'Наукові дослідження та розробки у сфері нанотехнологій',
    },
    {
      value: '541714',
      label: 'Наукові дослідження та розробки у сфері біотехнологій (крім нанобіотехнологій)',
    },
    {
      value: '541715',
      label: 'НДДКР у галузі фізичних, інженерних та біологічних наук (крім нанотехнологій та біотехнологій)',
    },
    {
      value: '54172',
      label: 'НДДКР у сфері соціальних та гуманітарних наук',
    },
  ],
  [ADVERTISING_SERVICES_INDUSTRY_GROUP]: [
    { value: '54181', label: 'Рекламні агенції' },
    { value: '54182', label: 'PR-агенції та служби зв’язків з громадськістю' },
    { value: '54183', label: 'Агенції з закупівлі медіареклами' },
    { value: '54184', label: 'Медіа-представництва та сейлз-хауси' },
    {
      value: '54185',
      label: 'Реклама в інтер’єрі та зовнішня реклама',
    },
    { value: '54186', label: 'Пряма поштова реклама (direct mail)' },
    {
      value: '54187',
      label: 'Розповсюдження рекламних матеріалів',
    },
    { value: '54189', label: 'Інші послуги у сфері реклами' },
  ],
  [OTHER_TECHNICAL_SERVICES_INDUSTRY_GROUP]: [
    {
      value: '54191',
      label: 'Маркетингові дослідження та опитування громадської думки',
    },
    { value: '54192', label: 'Фотопослуги' },
    {
      value: '54193',
      label: 'Послуги перекладу та усного тлумачення',
    },
    { value: '54194', label: 'Ветеринарні послуги' },
    {
      value: '54199',
      label: 'Інші професійні, наукові та технічні послуги',
    },
  ],
  [OFFICE_ADMINISTRATIVE_SERVICES_INDUSTRY_GROUP]: [],
  [FACILITIES_SUPPORT_SERVICES_INDUSTRY_GROUP]: [],
  [EMPLOYMENTS_SERVICES_INDUSTRY_GROUP]: [
    { value: '561311', label: 'Агенції з працевлаштування' },
    { value: '561312', label: 'Послуги з підбору керівників (executive search)' },
    {
      value: '56132',
      label: 'Послуги тимчасового персоналу (аутстафінг)',
    },
    { value: '56133', label: 'Професійні роботодавці (PEO-організації)' },
  ],
  [BUSINESS_SUPPORT_SERVICES_INDUSTRY_GROUP]: [
    { value: '56141', label: 'Послуги з підготовки документів' },
    { value: '56142', label: 'Кол-центри' },
    { value: '56143', label: 'Бізнес-центри обслуговування' },
    { value: '561431', label: 'Приватні поштові центри' },
    {
      value: '561439',
      label: 'Інші бізнес-центри обслуговування (включно з копі-центрами)',
    },
    { value: '56144', label: 'Колекторські агенції' },
    { value: '56145', label: 'Кредитні бюро' },
    {
      value: '561491',
      label: 'Послуги з вилучення заставного майна',
    },
    {
      value: '561492',
      label: 'Послуги судового протоколювання та стенографії',
    },
    { value: '561499', label: 'Інші послуги ділової підтримки' },
  ],
  [RESERVATION_SERVICES_INDUSTRY_GROUP]: [
    {
      value: '56151',
      label: 'Туристичні та туристично-екскурсійні агенції',
    },
    { value: '56152', label: 'Туроператори' },
    {
      value: '56159',
      label: 'Інші послуги з організації поїздок та бронювання',
    },
  ],
  [INVESTIGATION_AND_SECURITY_SERVICES_INDUSTRY_GROUP]: [
    {
      value: '561611',
      label: 'Послуги з розслідувань та перевірки благонадійності',
    },
    { value: '561612', label: 'Послуги охоронців та патрулювання' },
    { value: '561613', label: 'Інкасація та броньовані перевезення цінностей' },
    { value: '56162', label: 'Послуги з монтажу та обслуговування систем безпеки' },
  ],
  [SERVICES_TO_BUILDINGS_INDUSTRY_GROUP]: [
    {
      value: '56171',
      label: 'Дератизація, дезінсекція та боротьба зі шкідниками',
    },
    { value: '56172', label: 'Клінінгові та прибиральні послуги' },
    { value: '56173', label: 'Ландшафтні та озеленювальні роботи' },
    {
      value: '56174',
      label: 'Хімчистка килимів та м’яких меблів',
    },
    {
      value: '56179',
      label: 'Інші послуги з обслуговування будівель та житла',
    },
  ],
  [OTHER_SUPPORT_SERVICES_INDUSTRY_GROUP]: [
    { value: '56191', label: 'Послуги з пакування та маркування' },
    {
      value: '56192',
      label: 'Організація виставок, ярмарків та конференцій',
    },
    { value: '56199', label: 'Інші допоміжні бізнес-послуги' },
  ],
  [WASTE_COLLECTION_INDUSTRY_GROUP]: [
    { value: '562111', label: 'Збирання твердих побутових відходів' },
    { value: '562112', label: 'Збирання небезпечних відходів' },
    { value: '562119', label: 'Збирання інших відходів' },
  ],
  [WASTE_DISPOSAL_INDUSTRY_GROUP]: [
    {
      value: '562211',
      label: 'Обробка та видалення небезпечних відходів',
    },
    { value: '562212', label: 'Експлуатація полігонів твердих побутових відходів' },
    {
      value: '562213',
      label: 'Спалювання твердих відходів (інсинератори)',
    },
    {
      value: '562219',
      label: 'Інша обробка та видалення нешкідливих відходів',
    },
  ],
  [REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICE_INDUSTRY_GROUP]: [
    {
      value: '56291',
      label: 'Послуги з рекультивації та очищення довкілля',
    },
    {
      value: '56292',
      label: 'Сортувальні та переробні центри з відновлення матеріалів',
    },
    {
      value: '56299',
      label: 'Інші послуги з поводження з відходами',
    },
    {
      value: '562991',
      label: 'Обслуговування септиків та асенізаторські послуги',
    },
    {
      value: '562998',
      label: 'Інші різноманітні послуги у сфері управління відходами',
    },
  ],
  [ELEMENTARY_SCHOOLS_INDUSTRY_GROUP]: [],
  [JUNIOR_COLLEGES_INDUSTRY_GROUP]: [],
  [PROFESSIONAL_SCHOOLS_INDUSTRY_GROUP]: [],
  [BUSINESS_SCHOOLS_INDUSTRY_GROUP]: [
    { value: '61141', label: 'Бізнес-школи та школи секретарів' },
    { value: '61142', label: 'Курси комп’ютерної підготовки' },
    {
      value: '61143',
      label: 'Професійне та управлінське навчання',
    },
  ],
  [TRADE_SCHOOLS_INDUSTRY_GROUP]: [
    {
      value: '611511',
      label: 'Школи косметології та перукарського мистецтва',
    },
    { value: '611512', label: 'Школи льотної підготовки' },
    {
      value: '611513',
      label: 'Програми професійного навчання та стажування (apprenticeship)',
    },
    {
      value: '611519',
      label: 'Інші технічні та професійні училища',
    },
  ],
  [OTHER_SCHOOLS_INDUSTRY_GROUP]: [
    { value: '61161', label: 'Школи образотворчого мистецтва' },
    {
      value: '61162',
      label: 'Навчання у сфері спорту та відпочинку',
    },
    { value: '61163', label: 'Мовні школи' },
    {
      value: '61169',
      label: 'Інші навчальні заклади та види навчання',
    },
    {
      value: '611691',
      label: 'Підготовка до іспитів та репетиторство',
    },
    { value: '611692', label: 'Автошколи' },
    {
      value: '611699',
      label: 'Інші різноманітні школи та навчальні програми',
    },
  ],
  [EDUCATIONAL_SUPPORT_SERVICES_INDUSTRY_GROUP]: [],
  [PHYSICIANS_INDUSTRY_GROUP]: [
    {
      value: '621111',
      label: 'Медичні практики лікарів (крім спеціалістів з психічного здоров’я)',
    },
    {
      value: '621112',
      label: 'Медичні практики лікарів-психіатрів та інших фахівців з психічного здоров’я',
    },
  ],
  [DENTISTS_INDUSTRY_GROUP]: [],
  [OTHER_HEALTH_PRACTITIONERS_INDUSTRY_GROUP]: [
    {
      value: '62131',
      label: 'Кабінети мануальних терапевтів та хіропрактиків',
    },
    { value: '62132', label: 'Кабінети оптометристів' },
    {
      value: '62133',
      label: 'Кабінети психологів та інших фахівців з психічного здоров’я (крім лікарів)',
    },
    {
      value: '62134',
      label: 'Кабінети фізичних, трудових, мовних терапевтів та аудіологів',
    },
    { value: '621391', label: 'Кабінети лікарів-подіатрів' },
    {
      value: '621399',
      label: 'Кабінети інших медичних фахівців',
    },
  ],
  [OUTPATIENT_CARE_CENTERS_INDUSTRY_GROUP]: [
    { value: '61141', label: 'Центри з планування сім’ї' },
    {
      value: '61142',
      label: 'Амбулаторні центри психічного здоров’я та лікування залежностей',
    },
    { value: '61149', label: 'Інші амбулаторні медичні центри' },
  ],
  [MEDICAL_LABS_INDUSTRY_GROUP]: [
    { value: '621511', label: 'Медичні лабораторії' },
    { value: '621512', label: 'Центри діагностичної візуалізації' },
  ],
  [HOME_HEALTH_CARE_SERVICES_INDUSTRY_GROUP]: [],
  [OTHER_AMBULATORY_HEALTH_CARE_INDUSTRY_GROUP]: [
    {
      value: '62191',
      label: 'Служби швидкої медичної допомоги та перевезення пацієнтів',
    },
    { value: '621991', label: 'Банки крові та органів' },
    {
      value: '621999',
      label: 'Інші амбулаторні медичні послуги',
    },
  ],
  [GENERAL_MEDICAL_INDUSTRY_GROUP]: [],
  [SUBSTANCE_ABUSE_HOSPITALS_INDUSTRY_GROUP]: [],
  [SPECIALTY_HOSPITALS__INDUSTRY_GROUP]: [],
  [NURSING_CARE_FACILITIES_INDUSTRY_GROUP]: [],
  [RESIDENTIAL_INTELLECTUAL_INDUSTRY_GROUP]: [
    {
      value: '62321',
      label: 'Заклади проживання для осіб з інтелектуальними та розвитковими порушеннями',
    },
    {
      value: '62322',
      label: 'Стаціонарні заклади для людей з психічними розладами та залежностями',
    },
  ],
  [RETIREMENT_COMMUNITIES_INDUSTRY_GROUP]: [
    {
      value: '623311',
      label: 'Стаціонарні заклади для людей з психічними розладами та залежностями',
    },
    {
      value: '623312',
      label: 'Будинки для літніх людей з послугами підтриманого проживання',
    },
  ],
  [OTHER_RESIDENTIAL_CARE_INDUSTRY_GROUP]: [],
  [INDIVIDUAL_AND_FAMILY_SERVICES_INDUSTRY_GROUP]: [
    { value: '62411', label: 'Послуги для дітей та молоді' },
    {
      value: '62412',
      label: 'Послуги для людей похилого віку та осіб з інвалідністю',
    },
    {
      value: '62419',
      label: 'Інші соціальні послуги для окремих осіб та сімей',
    },
  ],
  [OTHER_RELIEF_SERVICES_INDUSTRY_GROUP]: [
    {
      value: '62421',
      label: 'Громадські харчові програми та продовольча допомога',
    },
    {
      value: '62422',
      label: 'Громадські житлові програми та послуги',
    },
    {
      value: '62423',
      label: 'Надання екстреної та іншої гуманітарної допомоги',
    },
  ],
  [VOCATIONAL_REHABILITATION_SERVICES_INDUSTRY_GROUP]: [],
  [CHILD_CARE_SERVICES_INDUSTRY_GROUP]: [],
  [PERFORMING_ARTS_COMPANIES_INDUSTRY_GROUP]: [
    {
      value: '71111',
      label: 'Театральні трупи та театри-ресторани',
    },
    { value: '71112', label: 'Танцювальні колективи та компанії' },
    { value: '71113', label: 'Музичні колективи та виконавці' },
    {
      value: '71119',
      label: 'Інші виконавські мистецькі колективи',
    },
  ],
  [SPECTATOR_SPORTS_INDUSTRY_GROUP]: [
    { value: '711211', label: 'Спортивні команди та клуби' },
    { value: '711212', label: 'Іподроми та гоночні траси' },
    { value: '711219', label: 'Інші видовищні спортивні заходи' },
  ],
  [PROMOTERS_OF_PERFORMING_ARTS_INDUSTRY_GROUP]: [
    {
      value: '71131',
      label: 'Організатори мистецьких, спортивних та подібних заходів із власними майданчиками',
    },
    {
      value: '71132',
      label: 'Організатори мистецьких, спортивних та подібних заходів без власних майданчиків',
    },
  ],
  [ARTISTS_AGENTS_AND_MANAGERS_INDUSTRY_GROUP]: [],
  [INDEPENDENT_ARTISTS_INDUSTRY_GROUP]: [],
  [AMUSEMENT_PARKS_INDUSTRY_GROUP]: [
    { value: '71311', label: 'Парки розваг та тематичні парки' },
    { value: '71312', label: 'Ігрові зали та аркади' },
  ],
  [GAMBLING_INDUSTRIES_INDUSTRY_GROUP]: [
    { value: '71321', label: 'Казино (крім готелів-казино)' },
    { value: '71329', label: 'Інша гральна діяльність' },
  ],
  [OTHER_AMUSEMENT_INDUSTRY_GROUP]: [
    { value: '71391', label: 'Гольф-клуби та заміські клуби' },
    { value: '71392', label: 'Гірськолижні комплекси' },
    { value: '71393', label: 'Марини та яхтові пристані' },
    {
      value: '71394',
      label: 'Фітнес- та спортивно-оздоровчі центри',
    },
    { value: '71395', label: 'Боулинг-клуби' },
    {
      value: '71399',
      label: 'Інша діяльність у сфері відпочинку та розваг',
    },
  ],
  [TRAVELER_ACCOMMODATION_INDUSTRY_GROUP]: [
    {
      value: '72111',
      label: 'Готелі (крім готелів-казино) та мотелі',
    },
    { value: '72112', label: 'Готелі-казино' },
    {
      value: '72119',
      label: 'Інші засоби розміщення мандрівників',
    },
    { value: '721191', label: 'Готелі типу bed-and-breakfast' },
    {
      value: '721199',
      label: 'Інші різновиди розміщення для мандрівників',
    },
  ],
  [RECREATIONAL_CAMPS_INDUSTRY_GROUP]: [
    {
      value: '721211',
      label: 'Кемпінги та парки для автодомів (RV-парки)',
    },
    {
      value: '721214',
      label: 'Рекреаційні та відпочинкові табори (крім кемпінгів)',
    },
  ],
  [WORKERS_CAMPS_INDUSTRY_GROUP]: [],
  [SPECIAL_FOOD_SERVICES_INDUSTRY_GROUP]: [
    {
      value: '72231',
      label: 'Контрактні оператори харчування (кейтеринг у закладах, лікарнях тощо)',
    },
    { value: '72232', label: 'Кейтерингові компанії' },
    {
      value: '72233',
      label: 'Пересувні пункти харчування (фудтраки тощо)',
    },
  ],
  [DRINKING_PLACES_INDUSTRY_GROUP]: [],
  [OTHER_EATING_PLACES_INDUSTRY_GROUP]: [
    { value: '722511', label: 'Ресторани з повним обслуговуванням' },
    {
      value: '722513',
      label: 'Заклади швидкого та обмеженого обслуговування',
    },
    {
      value: '722514',
      label: 'Кафетерії, гриль-буфети та шведські столи',
    },
    {
      value: '722515',
      label: 'Заклади перекусів та безалкогольних напоїв',
    },
  ],
  [AUTOMOTIVE_REPAIR_INDUSTRY_GROUP]: [
    { value: '811111', label: 'Загальний ремонт автомобілів' },
    { value: '811114', label: 'Спеціалізований ремонт автомобілів' },
    {
      value: '811121',
      label: 'Кузовний ремонт, фарбування та відновлення інтер’єру автомобілів',
    },
    {
      value: '811122',
      label: 'Майстерні з ремонту та заміни автоскла',
    },
    {
      value: '811191',
      label: 'Станції з заміни оливи та мастильних матеріалів',
    },
    { value: '811192', label: 'Автомийки' },
    {
      value: '811198',
      label: 'Інші послуги з ремонту та обслуговування автомобілів',
    },
  ],
  [ELECTRONICS_REPAIR_INDUSTRY_GROUP]: [],
  [COMMERCIAL_REPAIR_AND_MAINTENANCE_INDUSTRY_GROUP]: [],
  [PERSONAL_GOODS_REPAIR_INDUSTRY_GROUP]: [
    {
      value: '811411',
      label: 'Ремонт і обслуговування техніки для дому та саду',
    },
    {
      value: '811412',
      label: 'Ремонт побутової техніки',
    },
    {
      value: '81142',
      label: 'Перетяжка та ремонт меблів',
    },
    {
      value: '81143',
      label: 'Ремонт взуття та шкіряних виробів',
    },
    {
      value: '81149',
      label: 'Ремонт інших особистих та побутових речей',
    },
  ],
  [PERSONAL_CARE_SERVICES_INDUSTRY_GROUP]: [
    { value: '812111', label: 'Чоловічі перукарні (барбершопи)' },
    { value: '812112', label: 'Салони краси' },
    { value: '812113', label: 'Манікюрні та нігтьові салони' },
    { value: '81219', label: 'Інші послуги індустрії краси та догляду' },
    {
      value: '812191',
      label: 'Центри дієтології та корекції ваги',
    },
  ],
  [DEATH_CARE_SERVICES_INDUSTRY_GROUP]: [
    { value: '81221', label: 'Похоронні бюро та ритуальні послуги' },
    { value: '81222', label: 'Кладовища та крематорії' },
  ],
  [LAUNDRY_SERVICES_INDUSTRY_GROUP]: [
    {
      value: '81231',
      label: 'Пральні та хімчистки з монетною/самообслуговуванням',
    },
    {
      value: '81232',
      label: 'Хімчистки та пральні (крім самообслуговування)',
    },
    {
      value: '812331',
      label: 'Оренда та сервіс текстилю (лізинг білизни, спецодягу тощо)',
    },
    { value: '812332', label: 'Промислові пральні' },
  ],
  [OTHER_PERSONAL_SERVICES_INDUSTRY_GROUP]: [
    {
      value: '81291',
      label: 'Послуги догляду за тваринами (крім ветеринарії)',
    },
    {
      value: '81292',
      label: 'Послуги фотодруку та обробки зображень',
    },
    { value: '81293', label: 'Автостоянки та гаражі' },
    { value: '81299', label: 'Інші особисті послуги' },
  ],
  [RELIGIOUS_ORGANIZATIONS_INDUSTRY_GROUP]: [],
  [GRANTMAKING_INDUSTRY_GROUP]: [
    { value: '813211', label: 'Благодійні та грантодавчі фонди' },
    {
      value: '813212',
      label: 'Добровільні організації у сфері охорони здоров’я',
    },
    {
      value: '813219',
      label: 'Інші організації, що надають гранти та благодійну допомогу',
    },
  ],
  [SOCIAL_ADVOCACY_INDUSTRY_GROUP]: [
    { value: '813311', label: 'Правозахисні організації' },
    {
      value: '813312',
      label: 'Екологічні та природоохоронні організації',
    },
    {
      value: '813319',
      label: 'Інші організації соціального адвокації',
    },
  ],
  [SOCIAL_ORGANIZATIONS_INDUSTRY_GROUP]: [],
  [BUSINESS_LABOR_POLITICAL_INDUSTRY_GROUP]: [
    { value: '81391', label: 'Бізнес-асоціації' },
    {
      value: '81392',
      label: 'Професійні об’єднання та асоціації',
    },
    {
      value: '81393',
      label: 'Профспілки та подібні трудові об’єднання',
    },
    { value: '81394', label: 'Політичні організації та партії' },
    {
      value: '81399',
      label: 'Інші подібні організації (крім бізнес-, професійних, профспілкових та політичних)',
    },
  ],
  [MANAGEMENT_OF_COMPANIES_SECTOR]: [
    {
      value: '551111',
      label: 'Офіси банківських холдингових компаній',
    },
    {
      value: '551112',
      label: 'Офіси інших холдингових компаній',
    },
    {
      value: '551114',
      label: 'Корпоративні, дочірні та регіональні керівні офіси',
    },
  ],
  [RAIL_TRANSPORTATION_SUB_SECTOR]: [
    { value: '482111', label: 'Магістральні залізниці' },
    { value: '482112', label: 'Регіональні та місцеві залізниці (short line)' },
  ],
  [POSTAL_SERVICE_SUB_SECTOR]: [],
  [WAREHOUSING_AND_STORAGE_SUB_SECTOR]: [
    { value: '49311', label: 'Склади загального призначення' },
    { value: '49312', label: 'Холодильні склади та сховища' },
    {
      value: '49313',
      label: 'Склади та сховища сільськогосподарської продукції',
    },
    { value: '49319', label: 'Інші види складського зберігання' },
  ],
  [COMPUTING_INFRASTRUCTURE_SUB_SECTOR]: [],
  [WEB_SEARCH_PORTALS_SUB_SECTOR]: [
    { value: '51921', label: 'Бібліотеки та архіви' },
    {
      value: '51929',
      label: 'Веб-портали пошуку та інші інформаційні служби',
    },
  ],
  [MONETARY_BANK_SUB_SECTOR]: [],
  [LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR]: [],
  [MUSEUMS_SUB_SECTOR]: [
    { value: '71211', label: 'Музеї' },
    { value: '71212', label: 'Історичні місця та пам’ятки' },
    { value: '71213', label: 'Зоопарки та ботанічні сади' },
    {
      value: '71219',
      label: 'Природні парки та подібні установи',
    },
  ],
  [PRIVATE_HOUSEHOLDS_SUB_SECTOR]: [],
  [EXECUTIVE_LEGISLATIVE_SUB_SECTOR]: [
    { value: '92111', label: 'Органи виконавчої влади' },
    { value: '92112', label: 'Законодавчі органи' },
    { value: '92113', label: 'Діяльність у сфері державних фінансів' },
    {
      value: '92114',
      label: 'Об’єднані органи виконавчої та законодавчої влади',
    },
    {
      value: '92115',
      label: 'Органи племінного самоврядування корінних народів (American Indian та Alaska Native)',
    },
    {
      value: '92119',
      label: 'Інша загальна підтримка діяльності органів влади',
    },
  ],
  [JUSTICE_PUBLIC_ORDER_SUB_SECTOR]: [
    { value: '92211', label: 'Суди' },
    {
      value: '92212',
      label: 'Поліцейський захист та правопорядок',
    },
    {
      value: '92213',
      label: 'Прокуратура та юридичне представництво держави',
    },
    {
      value: '92214',
      label: 'Установи виконання покарань',
    },
    {
      value: '92215',
      label: 'Служби умовно-дострокового звільнення та пробації',
    },
    { value: '92216', label: 'Пожежна охорона' },
    {
      value: '92219',
      label: 'Інша діяльність у сфері правосуддя, громадського порядку та безпеки',
    },
  ],
  [ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR]: [
    {
      value: '92311',
      label: 'Адміністрування освітніх програм',
    },
    {
      value: '92312',
      label: 'Адміністрування програм громадської охорони здоров’я',
    },
    {
      value: '92313',
      label: 'Адміністрування соціальних програм (крім освіти, охорони здоров’я та програм для ветеранів)',
    },
    {
      value: '92314',
      label: 'Адміністрування програм для ветеранів',
    },
  ],
  [ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR]: [
    {
      value: '92411',
      label: 'Адміністрування програм охорони повітря, водних ресурсів та поводження з твердими відходами',
    },
    {
      value: '92412',
      label: 'Адміністрування програм збереження довкілля та природних ресурсів',
    },
  ],
  [ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR]: [
    {
      value: '92511',
      label: 'Адміністрування житлових програм',
    },
    {
      value: '92512',
      label: 'Адміністрування програм містобудування, розвитку громад та сільських територій',
    },
  ],
  [ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR]: [
    {
      value: '92611',
      label: 'Адміністрування загальноекономічних програм',
    },
    {
      value: '92612',
      label: 'Регулювання та адміністрування транспортних програм',
    },
    {
      value: '92613',
      label: 'Регулювання та адміністрування зв’язку, електро-, газо- та інших комунальних послуг',
    },
    {
      value: '92614',
      label: 'Регулювання аграрного ринку та торгівлі сільськогосподарською продукцією',
    },
    {
      value: '92615',
      label: 'Регулювання, ліцензування та інспекція різних комерційних секторів',
    },
  ],
  [SPACE_RESEARCH_SUB_SECTOR]: [],
  [NATIONAL_SECURITY_SUB_SECTOR]: [
    { value: '92811', label: 'Оборона та національна безпека' },
    { value: '92812', label: 'Міжнародні відносини та зовнішня політика' },
  ],
};
